<template>
  <div class="content taskAudit" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- 搜索区域 -->
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div"><span style="color: red">*</span>企业名称</div>
          <el-select
            v-model="page.tenantGuid"
            placeholder="请选择企业名称"
            class="ipt-sty"
            @change="tenantChange"
            filterable
            clearable
          >
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
            <div class="search-area-div"><span style="color: red">*</span>任务包名称</div>
            <el-select
              collapse-tags
              v-model="page.taskMainGuidList"
              placeholder="请选择任务包名称"
              class="ipt-sty"
              filterable
              clearable
              reserve-keyword
              multiple
              @change="taskPackageChange"
            >
              <el-option
                v-for="(item, index) in taskPackageList"
                :key="index"
                :label="item.taskTitleOrganisation || item.taskTitleShort"
                :value="item.guid"
              >
              </el-option>
            </el-select>
          </el-col>
        <el-col :span="6">
          <div class="search-area-div"><span style="color: red">*</span>问卷名称</div>
          <el-select
            collapse-tags
            v-model="page.surveyTenantGuid"
            placeholder="请选择问卷"
            class="ipt-sty"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in surveyList"
              :key="item.guid"
              :label="item.surveyTitle"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="t-left">
          <el-button size="small" type="expand" @click="searchShow = !searchShow"
            ><i :class="searchShow ? 'el-icon-arrow-up mr5' : 'el-icon-arrow-down mr5'"></i
            >{{ searchShow ? '收起筛选' : '更多筛选' }}</el-button
          >
          <el-button size="small" type="info" @click="searchButton">搜索</el-button>
          <el-button size="small" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <div class="search-block" v-if="searchShow">
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="search-area-div" style="width: 86px;">考核月份</div>
            <el-select
              v-model="monthType"
              size="mini"
              placeholder="请选择"
              class="w82"
              @change="accountMonthChange"
              filterable
            >
              <el-option
                v-for="item in monthList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <el-date-picker
              v-model="page.accountMonth"
              size="mini"
              class="ipt-sty"
              type="month"
              :clearable="false"
              value-format="yyyy-MM"
              placeholder="请选择月份"
              @change="accountMonthChange"
            >
            </el-date-picker>
          </el-col>

          <el-col :span="6">
            <div class="search-area-div">姓名/手机号</div>
            <el-input v-model.trim="page.staffName" class="ipt-sty" placeholder="请输入姓名/手机号"></el-input>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">部门名称</div>
            <el-select
              v-model="page.organisationGuid"
              placeholder="请选择部门名称"
              class="ipt-sty"
              clearable
              filterable
              multiple
              collapse-tags
              @focus="getOrganisation()"
              @change="organisationChange"
            >
              <el-option
                v-for="item in organisationList"
                :key="item.guid"
                :label="item.organisationName"
                :value="item.guid"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">审核日期</div>
            <el-date-picker
              v-model="approvalList"
              class="ipt-sty"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              clearable
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-col>

        </el-row>
        <el-row :gutter="24">
          <!-- <el-col :span="6">
            <div class="search-area-div">录入日期</div>
            <el-date-picker
              v-model="timeLists"
              class="ipt-sty"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              clearable
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-col> -->
          <el-col :span="6">
            <div class="search-area-div">是否有整改</div>
            <el-select v-model="page.isImprove" placeholder="请选择, 全部/是/否" class="ipt-sty" clearable filterable>
              <el-option
                v-for="(item, index) in rectificationOption"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <!-- <el-col :span="6">
            <div class="search-area-div">平台任务名称</div>
            <el-select
              multiple
              collapse-tags
              v-model="page.platformTaskName"
              placeholder="请选择平台任务名称"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option v-for="(item, index) in platformTaskName" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-col> -->
          <el-col :span="6">
            <div class="search-area-div">项目任务名称</div>
            <el-select
              multiple
              collapse-tags
              v-model="page.taskContentName"
              placeholder="请选择项目任务名称"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option v-for="(item, index) in taskContentName" :key="index" :label="item" :value="item"> </el-option>
            </el-select>
          </el-col>

          <el-col :span="6">
            <div class="search-area-div">
              <!-- <el-tooltip class="item" effect="dark"  placement="right-start">
                <template slot="content">
                  <div>{{'查询运营人员对某些数据撤回重审后, 企业确认的情况;'}}</div>
                  <div>{{'[已确认]表示企业对本次撤回重审无异议。'}}</div>
                </template>
                <i class="el-icon-question"></i>
              </el-tooltip> -->
              <el-popover trigger="hover" width="340" placement="right-start">
                <div>{{ '查询运营人员对某些数据撤回重审后, 企业确认的情况;' }}</div>
                <div>{{ '[已确认]表示企业对本次撤回重审无异议。' }}</div>
                <template slot="reference">
                  <i class="el-icon-question"></i>
                </template>
              </el-popover>

              是否确认
            </div>
            <el-select
              v-model="page.tenantAgreeFlag"
              placeholder="请选择"
              @clear="clearTenantAgreeFlag"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in tenantAgreeFlagOption"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">是否结算</div>
            <el-select
              v-model="page.settleState"
              placeholder="请选择, 全部/已结算/未结算"
              class="ipt-sty"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in settleAccountsOption"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="search-area-div">任务类别</div>
            <el-select
              v-model="page.taskBelongCategory"
              placeholder="请选择"
              class="ipt-sty"
              multiple
              collapse-tags
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in taskCategory"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <!-- <el-col :span="6">
            <div class="search-area-div">留存月</div>
            <el-date-picker size="mini" class="ipt-sty" value-format="yyyy-MM" clearable v-model="page.leftAccountMonth" type="month"
              placeholder="选择月">
            </el-date-picker>
          </el-col> -->
          <el-col :span="6" v-if="monthType=='留存月'">
            <div class="search-area-div">账单周期</div>
            <el-select size="mini" v-model="page.billCycle" style="flex: 1" placeholder="请选择" filterable>
              <el-option v-for="item in cycleData" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-col>
          <!-- <el-col :span="6">
            <div class="search-area-div">关键字</div>
            <el-input v-model.trim="page.keyWords" class="ipt-sty" placeholder="请输入"></el-input>
          </el-col> -->
          <el-col :span="6">
            <div class="search-area-div">
              <el-popover trigger="hover" width="420" placement="right-start">
                <div>{{ '请注意：为保证筛选效率，筛选这个条件时仅留基础条件' }}</div>
                <div>{{ '如药企、任务包名称、问卷名称、月份、部门、姓名/手机号，其他筛选内容有值则会清空掉！' }}</div>
                <template slot="reference">
                  <i class="el-icon-question"></i>
                </template>
              </el-popover>
              含异常照片
            </div>
            <el-select
              v-model="page.isSuspectPict"
              placeholder="请选择"
              class="ipt-sty"
              @change="onSuspectPhotoChange"
            >
              <el-option
                v-for="(item, index) in SuspectPhotoListOption"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">任务编号</div>
            <el-input
              v-model="page.taskNo"
              class="ipt-sty"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">排序规则</div>
            <el-select
              v-model="page.orderByRule"
              placeholder="请选择"
              class="ipt-sty"
              clearable
              filterable
              @clear="page.orderByRule = OrderByRuleEnum.ALL"
            >
              <el-option
                v-for="(item, index) in OrderByRuleOption"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
    </div>
    <div
      class="back-color-fff content-main-box"
      :style="'height:' + contentMainHeight + 'px;'"
      style="height: 100%"
    >
    <!-- 选项卡 -->
    <div class="searchHead-top">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="运营审核" name="first"></el-tab-pane>
        <el-tab-pane label="企业评价" name="second"></el-tab-pane>
      </el-tabs>
      <div>
          合计：共<span>{{ total.salesManTotal }}</span
          >人，<span>{{ total.totalRows }}</span
          >条记录
        </div>
    </div>
    <!-- 运营选项卡 -->
    <div class="searchHead" v-if="activeName === 'first'">
      <div class="searchHead-left">
        <div
          v-for="(item, index) in tabText"
          :key="index"
          :class="activeTab == index ? 'tab active' : 'tab'"
          @click="changeTab(index, item)"
        >
          <div>{{ item.name }}</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="sumLine">
        <!-- <div>
          共<span>{{ total.salesManTotal }}</span
          >人，<span>{{ total.totalRows }}</span
          >条记录
        </div> -->
        <div class="pitch active" v-if="activeTab == 1" @click="pitchAudit('1')">批量审核</div>
        <div class="pitch active" v-if="activeTab == 2 || activeTab == 3 || activeTab == 4" @click="pitchAudit('2')">
          批量撤回重审
        </div>
        <div class="pitch" @click="onShowImg"> {{  expandImage ? '收起图片' : '展开图片'  }}</div>
        <div class="pitch" @click="toExportInHandle">导入审核结果</div>
        <div class="pitch" @click="regardlessTask()">批量不计任务</div>
      </div>
    </div>
    <!-- 企业选项卡 -->
    <div class="searchHead" v-if="activeName === 'second'">
      <div class="searchHead-left">
        <div
          v-for="(item, index) in tabText2"
          :key="index"
          :class="activeTab2 == index ? 'tab active' : 'tab'"
          @click="changeTab2(index, item)"
        >
          <div>{{ item.name }}</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="sumLine">
        <!-- <div>
          共<span>{{ total.salesManTotal }}</span
          >人，<span>{{ total.totalRows }}</span
          >条记录
        </div> -->
        <div class="pitch" @click="pitchAudit('2')">批量撤回重审</div>
        <div class="pitch" @click="onShowImg"> {{  expandImage ? '收起图片' : '展开图片'  }}</div>
      </div>
    </div>
    <!-- 内容 -->
    <!-- <div class="contentBox back-color-fff " :style="isPatch || isPatchDownload ? 'padding-bottom:106px;' : 'padding-bottom:0px;'"> -->
      <el-table
        :data="taskDataList"
        :height="tableHeight"
        v-if="activeName === 'first'"
        stripe
        border
        ref="multipleTable"
        style="width: 100%"
        tooltip-effect="light"
        @selection-change="handleSelectionChange"
        @select-all="handleSelectionAll"
        :row-key="(row) => row.bizGuid"
        @row-click="handleClickTableRow"
       >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="40"
          header-align="center"
          fixed="left"
          align="center"
          :selectable="selectEnable"
        >
        </el-table-column>
        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          fixed="left"
          align="center"
        >
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column
          prop="staffName"
          width="80"
          label="任务类别"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.taskBelongCategory |taskBelongFilter }}
          </template>
        </el-table-column>

        <el-table-column
          prop="staffName"
          width="80"
          label="姓名"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.staffName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="mobileNo"
          width="100"
          label="手机号"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.mobileNo || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="organisationNames"
          width="120"
          label="部门名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.organisationNames | organisationFilter}}
          </template>
        </el-table-column>



        <!-- 题目名称 -->
        <el-table-column
          prop="customerGuid"
          :width="getColumnWidth(index)"
          :label="item"
          show-overflow-tooltip
          header-align="center"
          v-for="(item, index) in columnsList"
          :key="item"
          align="left"
        >

          <template slot="header" >
            <div v-if="isShowTooltip" @mouseover="onMouseOver($event.target)">
              {{ item }}
            </div>
            <el-tooltip :content="item" effect="light" placement="top" v-if="!isShowTooltip">
              <!-- 单行省略样式、鼠标移入事件 -->
              <div class="singe-line" @mouseover="onMouseOver($event.target)">{{ item }}</div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span v-if="scope.row.bizData.surveySubjects[index]">
              <span v-if="!scope.row.bizData.surveySubjects[index].hasImages">
                <span v-for="o in scope.row.bizData.surveySubjects[index]['column_' + index]">
                  {{ o.subjectAnswer || '-' }}
                </span>
                <!-- {{ scope.row.bizData.surveySubjects[index]['column_' + index] ||'-' }} -->
              </span>
              <!-- <span v-else @click="previewImg(scope.row.bizData.surveySubjects[index]['column_' + index])">查看图片</span> -->
               <TableContentImg
                :class="[
                  'txt-color', 
                  'flex',
                  {'h210': expandImage},
                ]" 
                v-else
                :showBtn="true"
                :activeTab="activeTab"
                :expandImage="expandImage"
                :index="index"
                :moveLeft="moveLeft"
                :moveRight="moveRight"
                :getImgUrl="getImgUrl"
                :previewImg="previewImg"
                :getComma="getComma"
                :scope="scope"
                :rowPageStatespageSize="rowPageStatespageSize"
                :rowPageStates="rowPageStates"
                :onAuditImgDialog="onAuditImgDialog"
                :onReportSuspectPict="onReportSuspectPict"
                :feedbackOptions="feedbackOptions"
              ></TableContentImg>
             
            </span>
            <span v-else>-</span>
            <!-- {{ scope.row.bizData.surveySubjects[index]?(getAnswer(scope.row.bizData.surveySubjects[index]['column_' + index])) : '-' }} -->
          </template>
        </el-table-column>
        <el-table-column
          width="160"
          prop="approvalTime"
          label="审核时间"
          header-align="center"
          show-overflow-tooltip
          align="left">
          <template slot-scope="scope">
            {{ scope.row.approvalTime | getDate }}
          </template>
        </el-table-column>
        <el-table-column
            prop="approveState"
            width="85"
            label="审核状态"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag slot="reference" size="mini" v-if="scope.row.approveState" :type="type[scope.row.approveState]">
                {{ approvalStateLK[scope.row.approveState] || '-' }}
              </el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="settleState"
            width="85"
            label="状态"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag slot="reference" size="mini" v-if="scope.row.settleState==='Y'" :type="type[scope.row.settleState]">
                {{ settleStateLK[scope.row.settleState] || '-' }}
              </el-tag>
              <el-tag slot="reference" size="mini" v-else-if="scope.row.isImprove==='Y'" :type="type[scope.row.isImprove]">
                {{ improveStateLK[scope.row.isImprove] || '-' }}
              </el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="taskNo"
            width="150"
            label="任务编号"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
        <el-table-column prop="customerGuid" width="300" label="操作" fixed="right" header-align="center" align="center">
          <template slot-scope="scope">
            <span class="txt-color" v-if="scope.row.approveState && scope.row.tenantAgreeFlag !== 'A' && scope.row.settleState !== 'Y' &&!scope.row.revoke" @click="revokeClick(scope.row)"> 撤回重审 |</span>
            <span class="txt-color" v-if="scope.row.settleState !== 'Y' && (scope.row.revoke||!scope.row.approveState)"  @click="toAudit(scope.row, 'Y', $event)"> 合格 |</span>
            <span class="txt-color" v-if="scope.row.settleState !== 'Y' && (scope.row.revoke||!scope.row.approveState)"  @click="toAudit(scope.row, 'P', $event)"> 部分合格 |</span>
            <span class="txt-color" v-if="scope.row.settleState !== 'Y' && (scope.row.revoke||!scope.row.approveState)"  @click="toAudit(scope.row, 'N', $event)"> 不合格 |</span>
            <span class="txt-color" v-if="scope.row.settleState !== 'Y' && !scope.row.billCycle" @click="regardlessTask(1, scope.row)"> 不计任务 |</span>
            <span class="txt-color" @click="viewReviewRecords(scope.row, 'service')"> 查看历史审核 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        :data="taskDataList"
        :height="tableHeight"
        v-else
        stripe
        border
        ref="multipleTable"
        style="width: 100%"
        tooltip-effect="light"
        @selection-change="handleSelectionChange"
        @select-all="handleSelectionAll"
        :row-key="(row) => row.bizGuid"
        @row-click="handleClickTableRow"
       >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="40"
          header-align="center"
          fixed="left"
          align="center"
          :selectable="selectEnable"
        >
        </el-table-column>
        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          fixed="left"
          align="center"
        >
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="taskContentName"
          min-width="130"
          label="任务名称"
          header-align="center"
          fixed="left"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="tenantName"
          min-width="150"
          label="企业名称"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>
          <el-table-column
            prop="approveState"
            v-if="activeName == 'second'"
            width="85"
            label="审核状态"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag slot="reference" size="mini" v-if="scope.row.approveState" :type="type[scope.row.approveState]">
                {{ approvalStateLK[scope.row.approveState] || '-' }}
              </el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="settleState"
            width="85"
            label="状态"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag slot="reference" size="mini" v-if="scope.row.settleState==='Y'" :type="type[scope.row.settleState]">
                {{ settleStateLK[scope.row.settleState] || '-' }}
              </el-tag>
              <el-tag slot="reference" size="mini" v-else-if="scope.row.isImprove==='Y'" :type="type[scope.row.isImprove]">
                {{ improveStateLK[scope.row.isImprove] || '-' }}
              </el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>

        <!-- <el-table-column
          prop="isImprove"
          min-width="80"
          label="整改状态"
          header-align="center"

          align="center"
          show-overflow-tooltip
        >
        <template slot-scope="scope">
          <el-tag slot="reference" size="mini" v-if="scope.row.isImprove=== 'Y'&&scope.row.settleState !== 'Y'" :type="type[scope.row.isImprove]">
            {{ improveStateLK[scope.row.isImprove] }}
          </el-tag>
          <span v-else>-</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="staffName"
          width="80"
          label="姓名"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.staffName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="mobileNo"
          width="100"
          label="手机号"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.mobileNo || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="organisationNames"
          width="120"
          label="部门名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.organisationNames | organisationFilter}}
          </template>
        </el-table-column>
        <el-table-column
          width="160"
          prop="approvalTime"
          label="审核时间"
          header-align="center"
          show-overflow-tooltip
          align="left">
          <template slot-scope="scope">
            {{ scope.row.approvalTime | getDate }}
          </template>
        </el-table-column>

        <el-table-column
          prop="customerInfo"
          label="企业最新评价"
          min-width="200"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ transformAppraise(scope.row) }}
          </template>
        </el-table-column>


        <!-- 题目名称 -->
        <el-table-column
          prop="customerGuid"
          :width="getColumnWidth(index)"
          :label="item"
          show-overflow-tooltip
          header-align="center"
          v-for="(item, index) in columnsList"
          :key="item"
          align="left"
        >
        <!-- <template slot="header">
            <div class="tooltip-hidden">
              <el-tooltip
              class="item"
              effect="light"
              :content="item"
              placement="bottom"
            >
              <div>{{ item }}</div>
            </el-tooltip>

            </div>

          </template>  -->
          <template slot="header" >
            <div v-if="isShowTooltip" @mouseover="onMouseOver($event.target)">
              {{ item }}
            </div>
            <el-tooltip :content="item" effect="light" placement="top" v-if="!isShowTooltip">
              <!-- 单行省略样式、鼠标移入事件 -->
              <div class="singe-line" @mouseover="onMouseOver($event.target)">{{ item }}</div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div 
              v-if="scope.row.bizData.surveySubjects[index]?.hasImages" 
              class="img-box flex txt-color"
            >
              <TableContentImg
                :showBtn="false"
                :activeTab="activeTab"
                :expandImage="expandImage"
                :index="index"
                :moveLeft="moveLeft"
                :moveRight="moveRight"
                :getImgUrl="getImgUrl"
                :previewImg="previewImg"
                :getComma="getComma"
                :scope="scope"
                :rowPageStatespageSize="rowPageStatespageSize"
                :rowPageStates="rowPageStates"
                :onAuditImgDialog="onAuditImgDialog"
                :onReportSuspectPict="onReportSuspectPict"
                :feedbackOptions="feedbackOptions"
              ></TableContentImg>
            </div>
            <div v-if="!scope.row.bizData.surveySubjects[index]?.hasImages">
              <span v-for="o in scope.row.bizData.surveySubjects[index]['column_' + index]">
                {{ o.subjectAnswer || '-' }}
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="customerGuid" width="300" label="操作" fixed="right" header-align="center" align="center">
          <template slot-scope="scope">
            <span class="txt-color" v-if="scope.row.approveState && scope.row.tenantAgreeFlag !== 'A' && scope.row.settleState !== 'Y' &&!scope.row.revoke" @click="revokeClick(scope.row)"> 撤回重审 |</span>
            <span class="txt-color" v-if="scope.row.settleState !== 'Y' && (scope.row.revoke||!scope.row.approveState)"  @click="toAudit(scope.row, 'Y', $event)"> 合格 |</span>
            <!-- :class="[{ 'mouse-disabled': scope.row.approveState && !scope.row.revoke },addClassName(scope.row, 'Y'),]" -->
            <span class="txt-color" v-if="scope.row.settleState !== 'Y' && (scope.row.revoke||!scope.row.approveState)"  @click="toAudit(scope.row, 'P', $event)"> 部分合格 |</span>
            <span class="txt-color" v-if="scope.row.settleState !== 'Y' && (scope.row.revoke||!scope.row.approveState)"  @click="toAudit(scope.row, 'N', $event)"> 不合格 |</span>
            <!-- <span class="txt-color" v-if="scope.row.settleState !== 'Y' && !scope.row.billCycle" @click="regardlessTask(1, scope.row)"> 不计任务 |</span> -->
            <span class="txt-color" @click="viewReviewRecords(scope.row, 'service')"> 查看历史审核 </span>
          </template>
        </el-table-column>
      </el-table>

    <!-- </div> -->
    <el-pagination
        class="pt pb back-color-fff content-pagination-box"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100, 200]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
    </el-pagination>
    <div  v-if="isPatch||isPatchDownload" style="height:56px;"></div>
    <!-- 批量审核按钮 -->
    <div class="pitchAll" v-if="isPatch">
      <!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
        >{{ '全选' }} {{ `已选${multipleSelection.length}个` }}</el-checkbox
      > -->
      <div class="pitchBtn">
        <!-- <el-checkbox v-if="page.approvalState !== 'U'" v-model="batchRevoke">撤回重审</el-checkbox> -->
        <!-- :class="['butt1', { 'is-disabled-btn': batchRevoke === false }]" -->
        <div
          :class="['butt1']"
          style="margin-left: 10px"
          v-if="isPatch"
          @click="toAuditPatch('Y')"
        >
          合格
        </div>
        <!-- { 'is-disabled-btn': batchRevoke === false } -->
        <div
          :class="['butt4']"
          v-if="isPatch"
          @click="toAuditPatch('P')"
          style="margin-top: 0; margin-left: 28px"
        >
          部分合格
        </div>
        <!-- , { 'is-disabled-btn': batchRevoke === false } -->
        <div
          :class="['butt2']"
          v-if="isPatch"
          @click="toAuditPatch('N')"
          style="margin-top: 0; margin-left: 28px"
        >
          不合格
        </div>
        <!-- <div
          class="butt3"
          v-if="isPatch && (activeTab == 2 || activeTab == 3 || activeTab == 4)"
          @click="toAuditPatch('R')"
        >
          撤销
        </div> -->
        <!-- <div class="butt3" style="margin-top: 0; margin-left: 28px" @click="regardlessTask()">不计任务</div> -->
        <div class="cancel-butt" @click="isPatch = false" style="margin-top: 0; margin-left: 28px">取消</div>
      </div>
    </div>
    <!-- 批量下载按钮 -->
    <div class="pitchAll" v-if="isPatchDownload">
      <!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
        >{{ '全选' }} {{ `已选${multipleSelection.length}个` }}</el-checkbox
      > -->
      <div class="pitchBtn">
        <div
          :class="['butt1']"
          style="margin-left: 10px"
          v-if="isPatchDownload"
          @click="batchDownload()"
        >
          确认下载
        </div>
        <div class="cancel-butt" @click="isPatchDownload = false" style="margin-top: 0; margin-left: 28px">取消</div>
      </div>
    </div>
  </div>
    <!-- // !勾选原因弹框 -->
    <el-dialog :title="checkedTitle" :close-on-click-modal="false" :visible.sync="dialogVisible" width="900px">
      <div slot="title" class="dialog-title">
        {{ checkedTitle }}
      </div>
      <div class="dialogCon">
        <!-- //! 是否需要企业人员确认 -->
        <div class="cols" v-if="showReApprove">
          <div class="col-itms">
            <div class="title">本次撤回后</div>
            <el-radio-group v-model="reApprove" style="padding-right: 5px">
              <el-radio :label="true">需要企业确认后生效</el-radio>
              <el-radio :label="false">无需企业确认直接生效</el-radio>
            </el-radio-group>
            <el-tooltip
              class="item"
              effect="dark"
              content="如果勾选了【需企业确认后生效】，表示需要企业人员同意撤回，审核结果才可生效。"
              placement="right-start"
              ><i class="el-icon-question"></i
            ></el-tooltip>
          </div>
        </div>
        <div class="cols" v-if="reApprove === true">
          <el-input v-model="revokeCause" placeholder="请填写撤回的原因"></el-input>
        </div>
        <div class="cols" style="display:flex">
          <div style="padding-right:20px">
            <div style="text-align: left;width: 65px" class="search-area-div">原因搜索</div>
            <el-input class="w300" @clear="searchReason" v-model="evaluationRuleDesc" clearable placeholder="请输入"></el-input>
          </div>
          <div style="padding-top:5px">
            <el-button size="mini" type="info" @click="searchReason">搜索</el-button>
          </div>
        </div>
        <div class="dialogCon-checkbox">
          <el-checkbox-group v-model="checkedIssues">
            <!-- <el-checkbox v-for="(item, index) in reasonList" :key="index" :label="item" class="checkbox-hover">{{
              item.evaluationRuleDesc
            }}</el-checkbox> -->
            <el-form>
              <el-form-item>
                <div v-for="(item, index) in reasonList" :key="index" class="dialogCon-checkbox-type">
                  <div style="height: 20px">{{ item.evaluationContent }}</div>
                  <div class="type-check-list">
                    <div class="type-check-item" v-for="(reasonItem, reasonIndex) in item.list" :key="reasonIndex">
                      <el-checkbox :label="reasonItem">{{ reasonItem.evaluationRuleDesc }}</el-checkbox>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </el-checkbox-group>
        </div>
        <!-- 原因说明 -->
        <div class="dialogCon-describe">
          <p>
            <span slot="label" style="color: red" v-if="requiredIssuesDesc">*</span>
            <span>原因说明</span>
          </p>
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-model="issuesDesc"
            :disabled="disabledInput"
            @input="checkedIssuesTextEvent"
            maxlength="200"
            show-word-limit
            placeholder="请输入内容"
            clearable
          ></el-input>
        </div>
        <!-- 整改照片 -->
        <!-- <div class="dialogCon-describe"  v-if="approvalState!=='Y'">
          <p>
            <span>上传整改参考照片</span>
          </p>
          <el-upload
            action="#"
            name="image"
            list-type="picture-card"
            :headers="token"
            accept=".jpg,.png,.jpeg"
            :limit="5"
            :on-exceed="handleExceed"
            :file-list="attach"
            :http-request="uploadBillImage"
            :on-remove="handleBillRemove"
            :on-preview="handlePictureCardPreview"
          >
            <div slot="image" slot-scope="{ file }">

              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />

              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span  class="el-upload-list__item-delete" @click="handleDownload(file)">
                  <i class="el-icon-download"></i>
                </span>
                <span class="el-upload-list__item-delete" @click="handleBillRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="info" @click="toAuditSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="多媒体文件查看" :visible.sync="dialogVisibleVodeo" :fullscreen="true">
        <iframe  style="width:100vw;height:100vh;border:0 none;" :src="videoPath"></iframe>
    </el-dialog>

    <ReviewRecords></ReviewRecords>
    <el-image-viewer style="z-index: 2050;" v-if="showViewer" :on-close="() => {showViewer = false}" :url-list="srcLists" />
    <AuditImgDialog ref="auditImgDialog" :getList="() => this.getData(3)">
    </AuditImgDialog>
  </div>
</template>
<script>
import { findLastKey, forEach } from 'lodash';
import recentDate from '@/uilt/recentDate';
import ReviewRecords from './components/reviewRecords';
import TableContentImg from './components/TableContentImg.vue';
import { getRegionName } from '@/uilt/region';
import { getSortList } from '@/uilt/tool';
import AuditImgDialog from './components/AuditImgDialog.vue';
import {
  isReportEnum,
  isReportMap,
  SuspectPhotoListOption,
  SuspectPhotoListEnum,
  ReportTypeEnum,
  OrderByRuleEnum,
  OrderByRuleOption,
} from "./enum";
import getTenantDetail from '../mixins/getTenantDetail';
import { ServiceProviderTypeEnum } from '../mixins/getTenantDetail'
export default {
  name: 'taskAudit',
  components: {
    TableContentImg,
    ReviewRecords,
    AuditImgDialog,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
  mixins:[getTenantDetail],
  data() {
    return {
      isReportEnum,
      isReportMap,
      SuspectPhotoListOption,
      SuspectPhotoListEnum,
      ReportTypeEnum,
      OrderByRuleEnum,
      OrderByRuleOption,
      columnHasImagesList: [],
      isShowTooltip :false,
      dialogVisibleVodeo:false,
      videoPath:null,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: localStorage.token,
      },
      attach: [],
      tableHeight: window.innerHeight - 304,
      contentMainHeight:window.innerHeight - 186,
      currentTask: {}, // 当前任务
      reApprove: false, // 是否征得企业同意
      revokeCause: '', // 撤回原因
      batchRevoke: null, // 批量撤回重审开关
      activeName: 'first',
      srcLists: [],
      showViewer: false,
      disabledInput: false, // 禁止输入
      searchShow: false,
      fullscreenLoading: false,
      checkAll: false,
      isIndeterminate: false,
      multipleSelection:[],
      approvalStateLK: {
        Y: '合格',
        P: '部分合格',
        N: '不合格',
      },
      settleStateLK: {
        Y: '已结算',
        N: '未结算',
      },
      improveStateLK: {
        Y: '已整改',
        N: '未整改',
      },
      type: {
        A: 'warning',
        Y: 'success',
        R: 'danger',
        N: 'info',
        P: 'warning',
      },
      tabText: [
        { name: '全部', value: '' },
        { name: '待审批', value: 'U' },
        { name: '合格', value: 'Y' },
        { name: '部分合格', value: 'P' },
        { name: '不合格', value: 'N' },
      ],
      tabText2: [
        { name: '待评价', value: 'U' },
        { name: '满意', value: 'Y' },
        { name: '不满意', value: 'N' },
      ],

      showFeedbackStatus: false, // # 企业一件反馈显示逻辑
      showRectification: false, // # 是否整改显示逻辑
      showSettleAccounts: false, // # 是否结算显示逻辑
      tenantAgreeFlagOption: [
        // 企业是否确认 option
        { name: '全部', value: '' },
        { name: '已确认', value: 'Y' },
        { name: '待确认', value: 'A' },
      ],
      feedbackStatusOption: [
        // 企业意见反馈 option
        { name: '全部', value: null },
        { name: '满意', value: 'Y' },
        { name: '不满意', value: 'N' },
      ],
      rectificationOption: [
        // 是否整改 option
        { name: '全部', value: null },
        { name: '已整改', value: 'Y' },
        { name: '未整改', value: 'N' },
      ],
      settleAccountsOption: [
        // 是否结算 option
        { name: '全部', value: null },
        { name: '已结算', value: 'Y' },
        { name: '未结算', value: 'N' },
      ],
      taskCategory:[
        { name: '平台专属', value: 3 },
        { name: '传世任务', value: 2 },
        { name: '项目任务', value: 1 },
      ],
      checkedTitle: '',
      tableImglist: [],
      list: [],
      activeTab: 1,
      activeTab2: 0,
      activeTabItem: { name: '待审批', value: 'U' },
      activeTabItem2: { name: '待评价', value: 'U' },
      tenantApproveState: 'U',
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        serviceTenantGuid: localStorage.guid,
        startTime: '',
        endTime: '',
        approvalStartTime: '', //审核时间开始时间
        approvalEndTime: '', //审核时间结束时间
        tenantGuid: null,
        organisationGuid: [],
        accountMonth: null,
        staffName: null,
        taskNameTypeCode: null,
        approvalState: 'U',
        tenantAgreeFlag: null,
        taskMainGuidList: null, // #任务包
        isImprove: null, // #是否有整改
        settleState: null, // #是否结算
        taskContentName: [],
        platformTaskName: [],
        surveyTenantGuid:null,//问卷名称
        taskBelongCategory:[],//任务类别
        //keyWords:'',//关键字
        // leftAccountMonth:'',//留存月
        billCycle:'',//账单周期
        isSuspectPict: SuspectPhotoListEnum.ALL,//是否存在疑似照片
        taskNo: '',
        orderByRule: OrderByRuleEnum.ALL, //排序规则
      },
      pageDetail: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
      },
      organisationList: [],
      tenantList: [],
      taskList: [],
      taskDataList: [],
      columnsList: [],
      expandImage: false,
      rowPageStates: {},
      rowPageStatespageSize: 2,
      timeLists: [],
      approvalList: [],
      taskPackageList: [], // #任务包list
      surveyList: [],//问卷列表
      total: {
        salesManTotal: 0,
        totalRows: 0,
        pictTotal: 0,
      },
      searchData: {
        name: '',
      },
      executeTime: [],
      isPatch: false, // 是否批量
      isPatchDownload: false, // 是否批量下载
      dialogVisible: false,
      bizItems: [],
      bizData: {},
      approvalState: '',
      reasonList: [], //不合格原因
      checkedIssues: [], //选中的原因
      issuesDesc: '', //原因说明
      taskContentName: [],
      platformTaskName: [],
      hoverContent: '',
      hoverLoading: false,
      selectDate: '',
      getRulesParam:null, // 获取审核原因的参数
      evaluationRuleDesc:'',
      monthType:'考核月',
      monthList:['考核月','留存月'],
      cycleData: ['一期', '二期', '三期', '四期', '五期', '六期', '七期', '八期', '九期', '十期', '十一期', '十二期', '十三期', '十四期', '十五期', '十六期', '十七期', '十八期', '十九期', '二十期', '二十一期', '二十二期', '二十三期', '二十四期', '二十五期', '二十六期', '二十七期', '二十八期', '二十九期', '三十期'],
      // 图片人工审核下拉选择
      feedbackOptions: [],
    };
  },
  watch: {
    isPatch(val) {
      if (val) {
        this.tableHeight = window.innerHeight - 343
      } else {
        this.tableHeight = window.innerHeight - 304
      }
    },
    isPatchDownload() {
      if (val) {
        this.tableHeight = window.innerHeight - 343
      } else {
        this.tableHeight = window.innerHeight - 304
      }
    },
    dialogVisibleVodeo(val){
      if(!val){
        this.videoPath = null;
      }
    },
    taskDataList(val) {
      if (val && val.length > 0) {
        let check = true;
        // val.forEach((i) => {
        //   if (!i.checked) {
        //     // this.checkAll = false;
        //     check = false;
        //   }
        // });
        if (check) {
          // this.checkAll = true;
        }
      }
    },
    dialogVisible(val) {
      // 监听原因说明弹框
      if (val) {
        this.reApprove = false;
        this.revokeCause = '';
        this.issuesDesc = '';
        this.evaluationRuleDesc = '';
        this.attach = [];
      }
    },
    checkedIssues: {
      handler(newVal, oldVal) {
        if (newVal && newVal.length) {
          this.disabledInput = false;
        } else {
          this.disabledInput = true;
        }
        this.checkedIssuesChange(newVal, oldVal);

        if (this.approvalState === 'Y' && newVal.length === 0) {
          this.issuesDesc = '';
        }
      },
    },
    searchShow(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 430;
        this.contentMainHeight = window.innerHeight - 336;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 304;
        this.contentMainHeight = window.innerHeight - 186;
        return;
      }
    },
  },
  filters:{
    organisationFilter(val){
      let str='-'
      if (!Array.isArray(val) || !val.length) {
        return str
      }
      if (val.length>1){
        val.forEach(item=>{
          str=str+item+'、'
        })
        // str=val[0]+' 等'+val.length+'家公司'
      }else if(val.length==1){
        str=val[0]
      }
      return str
    },
    taskBelongFilter(val) {
      let look={
        1:'项目任务',
        2:'传世任务',
        3:'平台专属'
      }
      return look[val]||'-'
    }
  },
  computed: {
    /**是否是 三方接包服务商*/
    isThirdPartyContractor() {
      try {
        // 可以直接访问到 mixins 中的 data 变量
        const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
        return serviceProviderType === ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR;
      } catch (error) {
        console.log(error);
      }
    },
    requiredIssuesDesc() {
      // 原因说明
      return (
        this.approvalState == 'P' ||
        this.approvalState == 'N' ||
        (this.approvalState == 'Y' && this.checkedIssues.length)
      );
    },
    // checkList() {
    //   let arr = this.taskDataList.filter((item) => item.checked === true);
    //   console.log('56',arr);

    //   return arr;
    // },
    messageSuccessTip() {
      return this.approvalState === 'R' ? '撤销成功' : '审核成功';
    },
    messageErrorTip() {
      return this.approvalState === 'R' ? '撤销失败' : '审核失败';
    },
    showReApprove() {
      // !企业是否需要确认勾选显示判断
      return (
        (this.isPatch && this.activeTab === 2 && (this.approvalState === 'P' || this.approvalState === 'N')) ||
        (this.currentTask.approveState === 'Y' && this.currentTask.tenantApproveState)
      );
    },
  },
  async created() {
    this.getFeedbackOptions()
    this.getToday();
    let { tenantGuid, staffName, accountMonth, taskMainGuidList, surveyTenantGuid } = this.$route.query
    await this.Mixins_getServiceProviderType();
    if (tenantGuid) {
      this.page.tenantGuid = tenantGuid;
      this.page.staffName = staffName;
      this.page.accountMonth = accountMonth

      this.getOrganisationList(tenantGuid);
      if (taskMainGuidList) {
        this.page.taskMainGuidList = JSON.parse(decodeURIComponent(taskMainGuidList))
        this.getTaskPackageList().then(() => {
          if (surveyTenantGuid) {
            this.page.surveyTenantGuid = surveyTenantGuid
          }
          this.getSurveyList()
        })
      }
    }
    this.getServiceProviderType();
    this.getTaskList();
  },
  methods: {
    // 从 surveySubjects 中提取图片URL
    extractAttachUrls(bizData) {
      if (!bizData?.surveySubjects?.length) {
        return [];
      }
      const urls = [];
      bizData.surveySubjects.forEach(subject => {
        Object.keys(subject).forEach(key => {
          if (key.startsWith('column_') && Array.isArray(subject[key])) {
            subject[key].forEach(sub => {
              // 只有当 subjectAnswer 包含"https://"时才认为是图片
              if (sub?.subjectAnswer?.includes('https://')) {
                const url = sub.subjectAnswer;
                if (url) {
                  let filename = url.split('/').pop();
                  urls.push({ path: url, fileName: filename })
                };
              }
            });
          }
        });
      });
      return urls;
    },
    getFeedbackOptions() { 
      let str = "";
      // 待审核
      if ([1].includes(this.activeTab)) {
        str = "图像识别不合规场景-待审核";
      }
      // 部分合格 不合格
      if ([3, 4].includes(this.activeTab)) {
        str = "图像识别不合规场景-已审核";
      }
      const list = this.$getValueListByKey(str);
      const feedbackOptions = list.map((value) => {
        return {
          value: value,
          label: this.$getNameByKey(value, str),
        };
      });
      this.feedbackOptions = feedbackOptions;
    },
    moveLeft(rowIndex) {
      if (!this.rowPageStates[rowIndex]) {
        this.$set(this.rowPageStates, rowIndex, { currentPage: 1 });
      }
      if (this.rowPageStates[rowIndex].currentPage > 1) {
        this.rowPageStates[rowIndex].currentPage--;
      }
    },
    moveRight(rowIndex, totalImages) {
      if (!this.rowPageStates[rowIndex]) {
        this.$set(this.rowPageStates, rowIndex, { currentPage: 1 });
      }
      const maxPage = Math.ceil(totalImages / this.rowPageStatespageSize);
      if (this.rowPageStates[rowIndex].currentPage < maxPage) {
        this.rowPageStates[rowIndex].currentPage++;
      }
    },
    extractPictFlag(url) {
      const fileName = url.substring(url.lastIndexOf('/') + 1);
      // 找到最后一个点的位置
      const lastDotIndex = fileName.lastIndexOf('.');
      // 从最后一个点往前截取24位
      const startIndex = Math.max(0, lastDotIndex - 24);
      const namePart = fileName.substring(startIndex, lastDotIndex);
      // 去掉下划线
      const finalName = namePart.replace(/_/g, '');
      return finalName;
    },
    async onReportSuspectPict(item, img, selectedValues) {
      // selectedValues 没有的情况代表是 ai相关的 reportType 就为 2
      let reportType = ReportTypeEnum.AI
      let afterSuspectTypes = img.suspectInfo?.suspectType ||  img.suspectInfo?.afterSuspectTypes;
      // let suspectTypes = [img.suspectInfoList[0]?.suspectType]
      if (selectedValues?.length) {
        reportType = ReportTypeEnum.MANUAL
        // suspectTypes = selectedValues
        afterSuspectTypes = selectedValues
      }
      const pictFlag = this.extractPictFlag(img.subjectAnswer);
      const query = {
        tenantGuid: item.tenantGuid,
        accountMonth: item.accountMonth?.replace("-", ""),
        functionCode: item.functionCode || item.taskContentType,
        bizGuid: item.bizGuid,
        pictPath: img.subjectAnswer,
        pictFlag,
        // suspectTypes,
        reportType,
        isReport: isReportEnum.Y,
        afterSuspectTypes,
      };
      if (img.suspectInfo?.isReport === isReportEnum.Y) {
        query.isReport = isReportEnum.N;
        query.reportType = ReportTypeEnum.WAIT_AUDIT;
        // query.suspectTypes = null;
        const { data } = await this.api.postJson(
          `/${serverConfig.msSalesPerformService}/report-suspect-pict/delete`,
          query
        );
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.error(data.msg);
        }
      } else {
        const { data } = await this.api.postJson(
          `/${serverConfig.msSalesPerformService}/report-suspect-pict/save`,
          query
        );
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.error(data.msg);
        }
      }
      this.getData(3);
    },
    onSuspectPhotoChange(v) {
      this.page.isSuspectPict = v;
       // 如果用了此筛选 "否含可疑照片"
      if (SuspectPhotoListEnum.ALL != v) {
        // 仅留基础条件如药企、任务包名称、问卷名称、月份、部门、姓名/手机号，其他筛选内容有值则清空掉。
        // tenantGuid
        // taskMainGuidList
        // surveyTenantGuid
        // accountMonth
        // organisationGuid
        // staffName
        this.page = {
          ...this.page,
          pageIndex: 1,
          pageSize: 50,
          totalPage: 0,
          totalRows: 0,
          serviceTenantGuid: localStorage.guid,
          startTime: '',
          endTime: '',
          approvalStartTime: '', //审核时间开始时间
          approvalEndTime: '', //审核时间结束时间
          taskNameTypeCode: null,
          approvalState: 'U',
          tenantAgreeFlag: null,
          isImprove: null, // #是否有整改
          settleState: null, // #是否结算
          taskContentName: [],
          platformTaskName: [],
          taskBelongCategory:[],//任务类别
          //keyWords:'',//关键字
          // leftAccountMonth:'',//留存月
          billCycle:'',//账单周期
          isSuspectPict: v,//是否存在疑似照片
          taskNo:'',
        }
        this.approvalList = []
      }
    },
    getServiceProviderType() {
      let url = `/${serverConfig.msCustomerService}/tenant-expand/servicer-credential/detail?tenantGuid=${localStorage.guid}`;
      this.api.get(url).then((resp) => {
        const { data } = resp;
        if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.serviceProviderType = data.data.serviceProviderType;
            this.getTenantList();
        }
      });
    },
    /** 参考图片 上传相关 开始*/
    handleBillRemove(file) {
      let self = this;
      self.attach.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.attach.splice(ind, 1);
        }
      });
    },
    uploadBillImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '产品图片',
              url: res.data.data,
            };
            self.attach.push(item);
            self.$message.success('上传成功');
          } else {
            self.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 5 个文件`);
    },
    handlePictureCardPreview(file) {
      this.srcLists = this.attach.map(e=> e.url);
      let index = this.srcLists.indexOf(file.url);
      if (index !== -1){
        this.srcLists=[file.url,...this.srcLists.slice(index + 1),...this.srcLists.slice(0, index)]
      }
      //设置 图片查看器 进行显示
      console.log('this.srcLists',this.srcLists,file);

      this.$forceUpdate();
      this.showViewer = true;
    },
    onShowImg() {
      this.expandImage = !this.expandImage;
    },
     // 审核图片
    onAuditImgDialog(item, img) {
      const data = {
        tenantGuid: this.page.tenantGuid,
        accountMonth: this.page.accountMonth,
        ...item,
        ...img,
        functionCode:item.functionCode || item.taskContentType,
        imgSrc: img.subjectAnswer,
        activeTab: this.activeTab,
      }
      this.$refs.auditImgDialog.open(data)  
    },
    previewImg(val,idx) {
      if (!val) {
        this.$message.error('暂无图片');
        return;
      }
      let srcList=val.map(item => item.subjectAnswer);
      console.log('aa',srcList);
      this.srcLists = srcList.slice(idx).concat(srcList.slice(0, idx));
      // srcList.forEach((item) => {
      //   this.srcLists.push(item.path);
      // });
      this.$forceUpdate();
      this.showViewer = true;
    },
    // 图片末尾添加逗号
    getComma(row,index,idx) {
      let str = '、';
      const imgList = this.getImgUrl(row.bizData.surveySubjects[index]['column_' + index])
      if (imgList.length == idx + 1) {
        str = '' 
      }
      return str
    },
    getImgUrl(val, currentPage = 1, pageSize = 10) {
      if (!val || !val.length) {
        return [];
      }
      
      const data = val.map(item => {
        const notSuspectInfo = item.suspectInfo ? false : true;
        const afterSuspectType = item?.suspectInfo?.afterSuspectType || item?.suspectInfo?.suspectType || []
        return {
          ...item,
           suspectInfo: {
            ...item.suspectInfo,
            afterSuspectType,
          },
          notSuspectInfo,
        }
      });
      
      // 只有在展开状态时才进行分页
      if (this.expandImage) {
        const start = (currentPage - 1) * pageSize;
        const end = currentPage * pageSize;
        return data.slice(start, end);
      }
      
      return data;
    },
    onMouseOver(target) {
      if (target.scrollWidth > target.clientWidth) {
        this.isShowTooltip = false;
      } else {
        this.isShowTooltip = true;
      }
      // 需要更新一下数据 不然气泡没更新
      this.$nextTick(() => {
        this.columnsList = [...this.columnsList];
        this.taskDataList = [...this.taskDataList];
      });
    },
    transformAppraise(row){
      let str='-'
      let count='-'
      if(row.tenantApproveState){
        str=row.tenantApproveState==='Y'?'满意':'不满意'
      }
      if(row.tenantEvaluateCount){
        count=row.tenantEvaluateCount
      }
      return row.abbreviation+" : "+str+' , '+'累计评价'+count+'次'
    },
    getToday() {
      let date = new Date(),
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      this.page.accountMonth = year + '-' + month;
      // this.getCycleData(this.page.tenantGuid)
    },
    checkedClick1(val) {
      this.$set(this.taskDataList, 0, item);
    },
    //获取药企
    getTenantList() {
      let self = this;
      let serviceProviderType = this.serviceProviderType;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
        relType: serviceProviderType == 2 ? '13' : ''
      };
      let url = `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`
      const serviceList = [
        ServiceProviderTypeEnum.THIRD_PARTY_SASS,
        ServiceProviderTypeEnum.GENERAL_CONTRACTOR,
      ];
      if (serviceList.includes(serviceProviderType)) {
        query = {
          tenantGuid: localStorage.guid,
        }
        url = `/${serverConfig.msCustomerService}/tenant/data/get-tenant-and-three-service`;
      }
      self.api
        .get(url, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data;
            if (self.tenantList && self.tenantList.length > 0 && !this.$route.query.tenantGuid) {
              self.page.tenantGuid = self.tenantList[0].sendTenantGuid;
              // 三方默认当前企业
              if (this.isThirdPartyContractor) {
                self.page.tenantGuid = localStorage.guid;
              }
              this.getOrganisationList(self.page.tenantGuid);
              this.getTaskPackageList(); // #获取任务包
              // this.getCycleData(self.page.tenantGuid)
            }
            // this.getData();
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    tenantChange(val) {
      if (val) {
        this.page.taskMainGuidList = null;
        this.page.surveyTenantGuid = null;
        // this.getCycleData(val)
        this.getTaskList();
        this.getOrganisationList(val);
        this.getTaskPackageList(); // #获取任务包
      }else{
        // this.cycleData = [];
      }
    },
    // todo 核算月下拉change
    accountMonthChange(val) {
      this.page.taskMainGuidList = null;
      this.page.surveyTenantGuid = null;
      if(this.monthType=='考核月'){
        this.page.billCycle=''
      }
      // this.getCycleData(val)
      this.getTaskList();
      this.getTaskPackageList(); // #获取任务包
    },
    // todo 部门下拉change
    organisationChange() {
      // this.getTaskPackageList() // #获取任务包
    },
    // todo 任务包change
    taskPackageChange(val) {
      console.log('taskPackageChange');
      if(val){
        this.getTaskList();
        this.getSurveyList()
      }

      this.$forceUpdate();
    },
    // getCycleFocus(){
    //   if (!this.page.tenantGuid) {
    //     this.$message.error('请选择药企名称!');
    //     this.cycleData = [];
    //     return;
    //   }
    //   if (!this.page.accountMonth) {
    //     this.$message.error('请选择考核月份!');
    //     this.cycleData = [];
    //     return;
    //   }
    // },
    //获取周期
    // getCycleData(val) {
    //   let self = this;
    //   if(!val){
    //     this.page.billCycle = null;
    //     return
    //   }
    //   if (!this.page.tenantGuid) {
    //     // this.$message.error('请选择药企名称!');
    //     return;
    //   }
    //   if (!this.page.accountMonth) {
    //     // this.$message.error('请选择核算月!');
    //     return;
    //   }

    //   let accountMonth = JSON.parse(JSON.stringify(this.page.accountMonth));
    //   accountMonth = accountMonth.replace('-','');
    //   self.api.postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/get-bill-cycle?accountMonth=${accountMonth}&tenantGuid=${this.page.tenantGuid}`).then((res) => {
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //       self.cycleData = res.data.data || [];
    //       if(self.cycleData && self.cycleData.length > 0){
    //         self.cycleData.forEach((i,index)=>{
    //           if(!i){
    //             self.cycleData[index] = '全部';
    //           }
    //         })
    //       }
    //     } else {
    //       self.$message.error(res.data.msg);
    //     }
    //   });
    // },
    //获取组织
    getOrganisationList(v) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
        sendTenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getOrganisation() {
      if (!this.page.tenantGuid) {
        this.$message.error('请选择企业名称后再选择部门!');
        return;
      }
    },
    //获取任务/菜单/平台名称
    getTaskList() {
      let self = this;
      let query = JSON.parse(JSON.stringify(this.page));
      let req = {
        tenantGuid: query.tenantGuid,
        taskContentType: ['WJDC'],
        taskMainGuidList: query.taskMainGuidList, // Assuming taskMainGuidList is always present
      };

      const formattedMonth = query.accountMonth ? query.accountMonth.replace('-', '') : '';

      if (this.monthType === '考核月') {
        req.accountMonth = formattedMonth;
      } else if (this.monthType === '留存月') {
        req.belongAccountMonth = formattedMonth;
      } else {
        req.accountMonth = formattedMonth;
      }

      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-audit/v2/task-search/drop-item`, req).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {

            self.page.taskContentName = [];
            self.page.platformTaskName = [];
            // self.page.surveyTenantGuid = null;
            // self.surveyList=[]
            self.taskContentName = res.data.data.taskContentName || [];
            self.platformTaskName = res.data.data.platformTaskName || [];
            // this.getSurveyList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 计算每列是否包含图片
    calculateColumnImageFlags() {
      this.columnHasImagesList = this.columnsList.map((_, columnIndex) => {
        return this.taskDataList.some(row => {
          const subject = row.bizData?.surveySubjects?.[columnIndex];
          return subject?.hasImages || false;
        });
      });
    },
    // 计算列宽
    getColumnWidth(columnIndex) {
      const isImageColumn = this.columnHasImagesList[columnIndex] || false;
      return isImageColumn ? (this.expandImage ? 340 : 220) : 180;
    },
    // 获取运营任务评审列表
    getData(type) {
      // this.isPatch = false; // todo关闭批量开关
      let self = this;
      // self.taskDataList = [];
      // self.columnsList = [];
      if (type == 1 || type == 2) {
        self.page.pageIndex = 1;
      }
      let query = JSON.parse(JSON.stringify(self.page));
      if (this.timeLists && this.timeLists.length > 0) {
        query.startTime = this.timeLists[0];
        query.endTime = this.timeLists[1];
      }
      if (this.approvalList && this.approvalList.length > 0) {
        query.approvalStartTime = this.approvalList[0];
        query.approvalEndTime = this.approvalList[1];
      }
      // if (query.accountMonth) {
      //   query.accountMonth = query.accountMonth.replace('-', '');
      // }
      // if (query.leftAccountMonth) {
      //   query.leftAccountMonth = query.leftAccountMonth.replace('-', '');
      // }
      if(this.monthType=='考核月'){
        query.accountMonth = query.accountMonth ? query.accountMonth.replace('-', '') : '';
      }else{
        query.leftAccountMonth = query.accountMonth ? query.accountMonth.replace('-', '') : '';
        delete query.accountMonth;
      }
      if (type !== 2 && type !== 3) {
        this.getTaskList();
      }
      if (!this.page.tenantGuid) {
        this.$message.error('请选择企业名称');
        return;
      }
      if ((!this.page.taskMainGuidList||this.page.taskMainGuidList.length<1)) {
        this.$message.error('请选择任务包名称');
        return;
      }
      if (!this.page.surveyTenantGuid) {
        this.$message.error('请选择问卷名称');
        return;
      }
      query.surveyTenantGuids=[query.surveyTenantGuid]
      self.fullscreenLoading = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/task-audit/v2/survey-task/get`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            if (res.data.data) {
              self.taskDataList = res.data.data.data.records||[];
              console.log('pp',self.taskDataList);
              this.$nextTick(() => {
                // this.$refs.multipleTable.doLayout()
                // this.$refs.multipleTable.clearSelection()
                // this.$refs.multipleTable.bodyWrapper.scrollTop = 0
              });
              self.columnsList = res.data.data.columns||[];
              try {
                self.taskDataList = self.taskDataList.map((item, index) => {
                  this.rowPageStates = {
                    [index]: { currentPage: 1 },
                  }
               
                  // 处理 surveySubjects
                  const processedSubjects = item.bizData.surveySubjects.map((subject, columnIndex) => {
                    const columnKey = `column_${columnIndex}`;
                    const answers = subject[columnKey] || [];
                    
                    // 判断该列是否包含图片
                    const hasImages = answers.some(answer => 
                      answer.subjectAnswer && answer.subjectAnswer.includes('https://')
                    );
                    const answersTime = answers.map(item => {
                      let subjectAnswer = item.subjectAnswer
                      // 'YYYY-MM-DD' 格式 改成 'YYYY-MM-DD dddd' 格式
                      if (typeof subjectAnswer === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(subjectAnswer)) {
                        subjectAnswer = this.$moment(subjectAnswer).locale('zh-cn').format('YYYY-MM-DD dddd');
                      }
                        return {
                          ...item,
                          subjectAnswer: subjectAnswer
                        }
                    })
                    
                    return {
                      ...subject,
                      [columnKey]: answersTime,
                      hasImages,
                      columnIndex // 保存列索引，方便使用
                    };
                  });
                  return {
                    ...item,
                    bizData: {
                      ...item.bizData,
                      surveySubjects: processedSubjects
                    },
                    hasAnyImages: processedSubjects.some(subject => subject.hasImages)
                  };
                });
                this.calculateColumnImageFlags();

               } catch (error) {
                console.log(error,'error')
              }

              self.page.totalPage = res.data.data.data.totalPages;
              self.page.totalRows = res.data.data.data.totalRows;
              this.$forceUpdate();
            }
            self.total = {
              salesManTotal: res.data.data.salesManTotal,
              totalRows: res.data.data.totalRows,
              // pictTotal: res.data.data.pictTotal,
            };
          } else {
            self.$message.error(res.data.msg);
            self.fullscreenLoading = false;
          }
        })
        .catch(() => {
          self.fullscreenLoading = false;
        });
    },
    //获取问卷列表
    getSurveyList() {
      this.page.surveyTenantGuid=null
      this.fullscreenLoading = true;
      this.surveyList=[]
      let userInfo = JSON.parse(localStorage.userInfo);
      let {accountMonth} = this.page
      let query = {
        pageIndex: 1,
        pageSize: -1,
        // organisationGuid: this.organisationGuid,
        // belongAccountMonth:accountMonth ? accountMonth.replace('-', '') : '',
        tenantGuid: this.page.tenantGuid,
        taskMainGuids: this.page.taskMainGuidList,
      };
      if (this.monthType === '考核月') {
        query.accountMonth = accountMonth;
      } else if (this.monthType === '留存月') {
        query.belongAccountMonth = accountMonth;
      } else {
        query.accountMonth = accountMonth;
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/survey/report/get-by-task`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data && res.data.data.length > 0) {
            this.surveyList = res.data.data;
            if(res.data.data.length==1){
              this.page.surveyTenantGuid = res.data.data[0].guid;
            }
            // this.page.surveyTenantGuid = this.surveyList[0].guid;
            // this.$set('page','surveyTenantGuid',JSON.parse(this.surveyList[0]).guid)
            console.log('6',this.page.surveyTenantGuid,this.surveyList);
            this.$forceUpdate()
            // this.getList();
            // this.getListAll();
          } else {
            this.surveyList = [];
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    empty() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        serviceTenantGuid: localStorage.guid,
        startTime: null,
        endTime: null,
        approvalStartTime: null, //审核时间开始时间
        approvalEndTime: null, //审核时间结束时间
        tenantGuid: this.page.tenantGuid,
        organisationGuid: [],
        accountMonth: null,
        staffName: null,
        taskNameTypeCode: null,
        approvalState: 'U',
        taskMainGuidList:null,
        isImprove: null, // #是否有整改
        settleState: null, // #是否结算
        taskContentName: [],
        platformTaskName: [],
        surveyTenantGuid:this.page.surveyTenantGuid,//问卷名称
        taskBelongCategory:[],//任务类别
        //keyWords:'',//关键字
        // leftAccountMonth:'',//留存月
        billCycle:'',//账单周期
        isSuspectPict: SuspectPhotoListEnum.ALL, // 是否含可疑照片
        taskNo: '',
        orderByRule: OrderByRuleEnum.ALL, //排序规则
      };
      this.timeLists = [];
      this.approvalList = [];
      // this.cycleData = [];
      // this.getData(1);
      this.getTaskPackageList();
      if (this.activeTabItem || this.activeTabItem2) {
        // this.changeTab(this.activeTab, this.activeTabItem);
        if (this.activeName === 'first' && this.activeTabItem) {
          this.changeTab(this.activeTab, this.activeTabItem);
        } else if (this.activeName === 'second' &&this.activeTabItem2) {
          this.changeTab2(this.activeTab2, this.activeTabItem2);
        }

      } else {
        this.getData(1);
      }
    },
    //获取图片
    getImgList(item, type) {
      let arr = [];
      let list = [];
      if (item.fieldConfig && item.fieldConfig.length > 0) {
        item.fieldConfig.forEach((i) => {
          if (
            i.fieldType == 'file' &&
            item.bizData[i.fieldName] &&
            (i.appSideType == '0' || i.appSideType == '2') &&
            i.showPosition.indexOf('3') > -1
          ) {
            let data = Array.isArray(item.bizData[i.fieldName])
              ? item.bizData[i.fieldName]
              : JSON.parse(item.bizData[i.fieldName]);
            data.forEach((j) => {
              j.type = i.fieldAlias;
            });
            arr = arr.concat(data);
          }
        });
      }
      if (type) {
        arr.forEach((m) => {
          list.push(m.path);
        });
      }
      return type ? list : arr;
    },
    //查看明细图片
    lookPic(row, list) {
      let tableImglist = [];
      let pic = row[list[0].fieldName];
      pic = Array.isArray(pic) ? pic : JSON.parse(pic);
      pic.forEach((i) => {
        tableImglist.push(i.path);
      });
      return tableImglist;
    },
    //表格显示判断
    getTable(row, items, config) {
      let name = '-';
      //判断是否是数字类型
      if (items.isDetail == 'Y' && items.fieldType == 'number') {
        let num = row[items.fieldName] ? Number(row[items.fieldName]) : 0;
        name = num.toFixed(2);
      } else if (row[items.fieldName]) {
        name = row[items.fieldName];
      } else if (items.fieldName === 'stockNum' && items.fieldDesc === '库存数量' && config.functionCode ==='KCXXCJ') { // #库存为0不展示问题
        name = row[items.fieldName];
      }
      return name;
    },
    //判断是否是产品
    isProduct(item) {
      let name = '';
      //市场调研
      if (item.fieldConfig && item.fieldConfig.length > 0 && item.functionCode == 'SCDY') {
        item.fieldConfig.forEach((i) => {
          if (
            (i.appSideType == '0' || i.appSideType == '2') &&
            i.showPosition.indexOf('3') > -1 &&
            i.isDetail.indexOf('N') > -1 &&
            i.fieldName == 'visitCategory'
          ) {
            name = item.bizData[i.fieldName];
          }
        });
      } else if ((item.fieldConfig && item.fieldConfig.length > 0 && item.functionCode == 'SQSH')||(item.fieldConfig && item.fieldConfig.length > 0 && item.functionCode == 'TSGL')||(item.fieldConfig && item.fieldConfig.length > 0 && item.functionCode == 'SWQT')||(item.fieldConfig && item.fieldConfig.length > 0 && item.functionCode == 'XCPPX') ||(item.fieldConfig && item.fieldConfig.length > 0 && item.functionCode == 'TKYL')) {
        item.fieldConfig.forEach((j) => {
          if (
            (j.appSideType == '0' || j.appSideType == '2') &&
            j.showPosition.indexOf('3') > -1 &&
            j.isDetail.indexOf('N') > -1 &&
            j.fieldName == 'goodsList'
          ) {
            name = 'goodsList';
          }
        });
      }else if (item.fieldConfig && item.fieldConfig.length > 0 && item.functionCode == 'YWCL') {
        item.fieldConfig.forEach((i) => {
          if (
            (i.appSideType == '0' || i.appSideType == '2') &&
            i.showPosition.indexOf('3') > -1 &&
            i.isDetail.indexOf('N') > -1 &&
            i.fieldName == 'products'
          ) {

            name = 'products';
          }
        });
      }else if ((item.fieldConfig && item.fieldConfig.length > 0 && item.functionCode == 'PYQFX')||(item.fieldConfig && item.fieldConfig.length > 0 && item.functionCode == 'SDYZ')) {
        item.fieldConfig.forEach((i) => {
          if (
            (i.appSideType == '0' || i.appSideType == '2') &&
            i.showPosition.indexOf('3') > -1 &&
            i.isDetail.indexOf('N') > -1 &&
            i.fieldName == 'goods'
          ) {

            name = 'goods';
          }
        });
      }


      return name;
    },
    //是否显示产品
    isProductShow(item) {
      let flag = false;
      let fieldConfig = item.fieldConfig;
      if (fieldConfig && fieldConfig.length > 0) {
        fieldConfig.forEach((i) => {
          if (
            (i.fieldName == 'competitors' || i.fieldName == 'goodsList'|| i.fieldName == 'goods'|| i.fieldName == 'products') &&
            (i.appSideType == '0' || i.appSideType == '2') &&
            i.showPosition.indexOf('3') > -1
          ) {
           // alert('888')
            flag = true;
          }
        });
      }
      // console.log('flag',flag);

      return flag;
    },
    //获取产品
    getProduct(item) {
      let name = '-';
      let arr = [];
      if (item.bizData && item.bizData.bizDataDetail && item.bizData.bizDataDetail.length > 0) {
        item.bizData.bizDataDetail.forEach((i) => {
          arr.push(i.goodsName ? i.goodsName : i.myGoodsName);
        });
      }
      if (item.bizData && item.bizData.products && item.bizData.products.length > 0) {
        item.bizData.products.forEach((i) => {
          arr.push(i.goodsName ? i.goodsName : i.myGoodsName);
        });

      }
      if (arr.length > 0) {
        name = arr.toString();
      }
      // console.log("ooo",name,item.functionCode)
      return name;
    },
    //多选
    // checkedClick(item, index) {
    //   item.checked = !item.checked;
    //   this.$set(this.taskDataList, index, item);
    //   // console.log(item);
    // },
    //多选-点击文本框
    // checkedClickBox(val, item, index) {
    //   item.checked = val;
    //   this.$set(this.taskDataList, index, item);
    //   // console.log(item);
    // },
    //获取字段名称
    getFieldName(fieldConfig, type, item) {
      let arr = [];
      if (fieldConfig && fieldConfig.length > 0) {
        //列表
        if (type == 1) {
          let locationArr = [];
          fieldConfig.forEach((i) => {
            if ( // !排除产品字段单独处理 在[产品名称]单独处理
              i.fieldType !== 'file' &&
              (i.appSideType == '0' || i.appSideType == '2') &&
              i.showPosition.indexOf('3') > -1 &&
              i.isDetail.indexOf('N') > -1 &&
              !(item.functionCode == 'SQSH' && i.fieldName == 'goodsList') &&
              !(item.functionCode == 'TKYL' && i.fieldName == 'goodsList') &&
              !(item.functionCode == 'SCDY' && i.fieldName == 'competitors')&&
              !(item.functionCode == 'TSGL' && i.fieldName == 'goodsList')&&
              !(item.functionCode == 'SWQT' && i.fieldName == 'goodsList')&&
              !(item.functionCode == 'XCPPX' && i.fieldName == 'goodsList')&&
              !(item.functionCode == 'YWCL' && i.fieldName == 'products')&&
              !(item.functionCode == 'PYQFX' && (i.fieldName == 'goods'||i.fieldName == 'campaignsTypeText'))&&
              !(item.functionCode == 'SDYZ' && i.fieldName == 'goods')
            ) {
              if (i.fieldType == 'location') {
                locationArr.push(i);
              } else {
                arr.push(i);
              }
            }
          });
          arr = arr.concat(locationArr);
          //表格
        } else if (type == 2) {
          fieldConfig.forEach((i) => {
            if (
              i.fieldType !== 'file' &&
              (i.appSideType == '0' || i.appSideType == '2') &&
              i.showPosition.indexOf('3') > -1 &&
              i.isDetail.indexOf('Y') > -1
            ) {
              arr.push(i);
            }
          });
          //图片
        } else if (type == 3) {
          fieldConfig.forEach((i) => {
            if (
              i.fieldType == 'file' &&
              (i.appSideType == '0' || i.appSideType == '2') &&
              i.showPosition.indexOf('3') > -1 &&
              i.isDetail.indexOf('Y') > -1
            ) {
              arr.push(i);
            }
          });
        }
      }
      // console.log(arr)
      return arr;
    },
    //获取字段内容
    getFieldCon(item, field) {
      try {
        let name = '-';

        //签到位置处理
        if (field.fieldType == 'location' && item.bizData && item.fieldConfig && item.bizData[field.fieldName]) {
          let obj = item.bizData[field.fieldName];
          let data = obj && JSON.parse(obj);
          if (data) {
            let space = data.space ? '(' + '偏移量：' + (data.space || 0) + '公里)' : '(无偏移量)';
            name = space ? (data.title || data.addressAll) + space : data.title || data.addressAll;
          }
          //拜访客户类型处理
        } else if (item.bizData && item.functionCode == 'SCDY' && field.fieldName == 'visitObjectType') {
          field.extensionConfig.additionalProp1.config.forEach((i) => {
            if (item.bizData[field.fieldName] == i.value && item.bizData[field.fieldName] !== '3') {
              name = i.text;
            } else if (item.bizData[field.fieldName] == i.value && item.bizData[field.fieldName] == '3') {
              name = '医生';
            }
          });
          //拜访时长处理
        } else if (item.bizData && item.functionCode == 'SCDY' && field.fieldName == 'visitDuration') {
          name = item.bizData[field.fieldName] ? recentDate.minTime(item.bizData[field.fieldName]) : '-';
          //单选项处理非市场调研
        } else if (
          // item.taskContentType == 'SCDY' &&
          item.bizData &&
          field.fieldType == 'radio' &&
          field.fieldName !== 'visitObjectType'
        ) {
          if (field.selectItemList) {
            field.selectItemList.forEach((j) => {
              if (item.bizData[field.fieldName] == j.value) {
                name = j.text;
              }
            });
            if (name == '-') {
              name = item.bizData[field.fieldName] || '-';
            }
          }
          //市场调研医生多选处理
        } else if (item.bizData && item.functionCode == 'SCDY' && field.fieldName == 'doctorInfo') {
          let data = item.bizData[field.fieldName];
          if (!data) {
            data = item.bizData['addressListInfo'];
          }
          let arr = [];
          let list = data && JSON.parse(data);
          if (list) {
            list.forEach((m) => {
              let info = m.medDeptName ? `-${m.medDeptName}` : '' // !医生对应科室
              arr.push(`${m.name}${item.bizData.visitObjectType == 2 ? '' : info}`);
            });
            if (list[0] && list[0].medDeptName) {
              name = arr.join('、'); // !医生名称特殊处理
            } else {
              name = arr.toString();
            }
          }
          //医生建档选择产品处理
        } else if (item.bizData && item.functionCode == 'YSJD' && field.fieldName == 'goodsInfoList') {
          let data = item.bizData[field.fieldName];
          if (!data) {
            data = item.bizData['goodsInfoList'];
          }
          let arr = [];
          let list = data;
          if (list) {
            list.forEach((m) => {
              arr.push(m.goodsName);
            });
            name = arr.toString();
          }
          //核算月格式处理
        } else if (item.bizData && field.fieldType == 'month') {
          let obj = item.bizData[field.fieldName] ? item.bizData[field.fieldName] : null;
          if (obj) {
            name = obj.substr(0, 4) + '年' + obj.substr(4, 2) + '月';
          } else {
            name = '-';
          }
          //KHDK偏移量处理
        } else if (item.bizData && item.functionCode == 'KHDK' && field.fieldName == 'enterClockInRadius') {
          //单选项处理非市场调研
          name = item.bizData[field.fieldName] ? item.bizData[field.fieldName] : '无偏移量';
        } else if (
          item.bizData &&
          item.functionCode == 'ZCXXSJ' &&
          (field.fieldName == 'coverAreaJson' || field.fieldName == 'inputDate' || field.fieldName == 'publishDate')
        ) {
          name = this.getFieldCon_ZCXXSJ(item, field, name); // 政策信息收集特殊处理
        } else if (item.functionCode == 'XSBF' && field.fieldName !== 'customerType') {
          // !客户类型不走特殊处理
          // 线上拜访特殊处理
          name = this.getFieldCon_XSBF(item, field);
        }else if (item.bizData && item.functionCode == 'ZBHZTJ' && field.fieldName == 'medDeptList') {
          name = item.bizData && item.bizData[field.fieldName] ? item.bizData[field.fieldName][0].name : '-';
        }else if (item.bizData && item.functionCode == 'HCPD' && field.fieldName == 'department') {
          name = item.bizData && item.bizData[field.fieldName] ? JSON.parse(item.bizData[field.fieldName])[0].name : '-';
        }else {
          if (item.bizData && field.fieldName == 'accountMonth') {
            name = item.accountMonth.substr(0, 4) + '年' + item.accountMonth.substr(4, 2) + '月' || '-';
          } else if(field.fieldName === 'stockTotal' && field.fieldDesc === '库存总数量' && item.functionCode == 'KCXXCJ'){ // #库存为0不展示问题
            name = item.bizData ? item.bizData[field.fieldName] :'-' ;
          } else {
            name = item.bizData && item.bizData[field.fieldName]!=null ? item.bizData[field.fieldName] : '-';
          }
        }

        return name;
      } catch (error) {
        console.error(error)
      }

    },
    getFieldCon_ZCXXSJ(item, field) {
      let name = '-';
      if (field.fieldName == 'coverAreaJson') {
        name = item.bizData[field.fieldName]
          ? getRegionName(JSON.parse(item.bizData[field.fieldName])).join('、')
          : '-';
      } else if (field.fieldName == 'inputDate') {
        name = item.bizData[field.fieldName] ? this.$moment(item.bizData[field.fieldName]).format('YYYY-MM-DD') : '-';
      } else if (field.fieldName == 'publishDate') {
        name = item.bizData[field.fieldName] ? this.$moment(item.bizData[field.fieldName]).format('YYYY-MM-DD') : '-';
      }
      return name;
    },
    // 线上拜访特殊处理
    getFieldCon_XSBF(item, field) {
      let name = '-';
      let readInfo = null; // 线上拜访阅读信息
      if (item.functionCode == 'XSBF' && item.bizData.readInfo) {
        // 获取线上拜访阅读信息
        readInfo =
          JSON.parse(item.bizData.readInfo) && Array.isArray(JSON.parse(item.bizData.readInfo))
            ? JSON.parse(item.bizData.readInfo)[0]
            : null;
      }
      if (item.bizData && item.functionCode == 'XSBF' && field.fieldName == 'readState') {
        // todo 线上拜访特殊处理 阅读状态加阅读市场
        name = item.bizData[field.fieldName] ? `已读, 阅读${this.formatSeconds(readInfo['readTime'])}` : '-';
      } else if (item.bizData && item.functionCode == 'XSBF' && field.fieldName == 'KHPJ') {
        // todo 线上拜访特殊处理 客户评价
        if (readInfo.readerInfo && typeof readInfo.readerInfo === 'string') {
          let readerInfo = JSON.parse(readInfo.readerInfo);
          name = `${readerInfo.key}${readerInfo.value.length ? ':' : ''} ${readerInfo.value.toString()}`;
        }
      } else if (item.bizData && item.functionCode == 'XSBF' && field.fieldName == 'YDRQ') {
        // todo 线上拜访特殊处理 阅读日期
        name = readInfo && readInfo.readDateTime ? `${this.$moment(readInfo.readDateTime).format('YYYY-MM-DD')}` : '-';
      } else if (item.bizData && item.functionCode == 'XSBF' && field.fieldType == 'input') {
        name = item.bizData[field.fieldName] ? item.bizData[field.fieldName] : '-';
      }
      return name;
    },
    //单个审核
    toAudit(item, type, event) {
      let { target } = event;
      let { className } = target;
      // if (~className.indexOf('is-disabled-btn')) {
      //   return;
      // } else if (~className.indexOf('is-selected-p')) {
      //   return;
      // } else if (~className.indexOf('is-selected-y')) {
      //   return;
      // } else if (~className.indexOf('is-selected-n')) {
      //   return;
      // }
      /* else if (item.approveState === type) {
        this.$message.warning(`不能重复选择【${this.approvalStateLK[type]}】`);
        return;
      } */
      // if (!item.revoke) {
      //   return;
      // }

      this.bizItems = [];
      this.bizData = {};
      this.checkedIssues = [];
      this.reApprove = false;
      this.revokeCause = '';
      this.currentTask = item;
      this.approvalState = type;
      let obj = {
        tenantGuid: item.tenantGuid,
        taskDetailGuid: item.taskDetailGuid,
        taskContentType: item.taskContentType,
        bizGuid: item.bizGuid,
        staffGuid: item.staffGuid,
        staffName: item.staffName,
        accountMonth: item.accountMonth,
        bizData: item.bizData,
        attach: this.extractAttachUrls(item.bizData),
      };
      this.bizItems.push(obj);
      if (type == 'Y') {
        this.checkedTitle = '请选择合格原因';
      } else if (type == 'N') {
        this.checkedTitle = '请选择不合格原因';
      } else if (type == 'P') {
        this.checkedTitle = '请选择部分合格原因';
      }
      if (type !== 'R') {
        this.getAuditData(item);
        this.dialogVisible = true;
      } else {
        //撤销
        this.$confirm('确定撤销吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.toAuditRequire();
          })
          .catch(() => {});
      }
    },
    //批量审核
    async toAuditPatch(type) {
      this.currentTask = { revoke: this.batchRevoke === true }; // 清空单条记录，保留批量重审模式
      this.bizItems = [];
      this.bizData = {};
      this.checkedIssues = [];
      this.approvalState = type;
      // let flag = this.taskDataList.findIndex((i) => i.checked);
      // if (flag < 0) {
      //   this.$message.error('请勾选数据');
      //   return;
      // }
      if(this.multipleSelection.length<1){
        this.$message.error('请勾选数据');
        return;
      }
      if (type == 'Y') {
        this.checkedTitle = '请选择合格原因';
      } else if (type == 'N') {
        this.checkedTitle = '请选择不合格原因';
      } else if (type == 'P') {
        this.checkedTitle = '请选择部分合格原因';
      }

      let oneTask = this.taskDataList[0];
      // if (oneTask.approveState === type) {
      //   this.$message.warning(`不能重复选择【${this.approvalStateLK[type]}】`);
      //   return;
      // }
      if (type !== 'R') {
        await this.getAuditDataPatch();
        this.dialogVisible = true;
      } else {
        this.toAuditRequire();
      }
    },
    //不计任务
    regardlessTask(type, item) {
      let self = this;
      let bizItems = [];
      this.$confirm('不计任务后，该任务将不进行结算，确认操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (type !== 1) {
            // let flag = this.taskDataList.findIndex((i) => i.checked);
            // if (flag < 0) {
            //   this.$message.error('请勾选数据');
            //   return;
            // }
            if(this.multipleSelection.length<1){
              this.$message.error('请勾选数据');
              return;
            }
            // this.taskDataList.forEach((items) => {
            this.multipleSelection.forEach((items) => {
              // if (items.checked) {
                let obj = {
                  tenantGuid: items.tenantGuid,
                  taskDetailGuid: items.taskDetailGuid,
                  taskContentType: items.taskContentType,
                  bizGuid: items.bizGuid,
                  staffGuid: items.staffGuid,
                  staffName: items.staffName,
                };
                bizItems.push(obj);
              // }
            });
          } else {
            bizItems = [
              {
                tenantGuid: item.tenantGuid,
                taskDetailGuid: item.taskDetailGuid,
                taskContentType: item.taskContentType,
                bizGuid: item.bizGuid,
                staffGuid: item.staffGuid,
                staffName: item.staffName,
              },
            ];
          }
          let query = {
            serviceTenantGuid: localStorage.guid,
            bizItems,
            approvalState: 'D',
          };
          self.fullscreenLoading = true;
          self.api
            .postJson(`/${serverConfig.msSalesPerformService}/task-audit/v2/task/set-invalid`, query)
            .then((res) => {
              self.fullscreenLoading = false;
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                this.$message.success('设置成功');
                this.getData(3);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    // todo初次评审接口
    toAuditRequire() {
      this.fullscreenLoading = true;
      if (this.isPatch) {
        // this.taskDataList.forEach((item) => {
        this.multipleSelection.forEach((item) => {
          // if (item.checked) {
            let obj = {
              tenantGuid: item.tenantGuid,
              taskDetailGuid: item.taskDetailGuid,
              taskContentType: item.taskContentType,
              bizGuid: item.bizGuid,
              staffGuid: item.staffGuid,
              staffName: item.staffName,
              accountMonth: item.accountMonth,
              bizData: item.bizData,
              attach: this.extractAttachUrls(item.bizData),
            };
            this.bizItems.push(obj);
          // }
        });
      }
      let query = {
        serviceTenantGuid: localStorage.guid,
        bizItems: this.bizItems,
        approvalState: this.approvalState,
        checkedIssues: this.approvalState == 'R' ? [] : this.checkedIssues,
        issuesDesc: this.issuesDesc, // !运营人员原因说明
        attach:this.attach.length?this.attach:null,//整改参考照片
      };
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/task-audit/v2/task/audit`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.fullscreenLoading = false;
            this.$message.success(this.messageSuccessTip);
            this.dialogVisible = false;
            this.checkedIssues = [];
            if (this.taskDataList.length == this.bizItems.length && this.page.pageIndex > 1) {
              this.page.pageIndex = this.page.pageIndex - 1;
            }
            // this.page.pageIndex = 1;
            this.$refs.multipleTable?.clearSelection();
            this.getData(3);
          } else {
            this.$message.error(`${this.messageErrorTip}${res.msg ? `:${res.msg}` : ''}`);
            this.fullscreenLoading = false;
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    revokeClick(row){
      this.$set(row, 'revoke', true)
      this.$forceUpdate()
    },
    // todo撤回重审接口
    toRevokeAudit() {
      this.fullscreenLoading = true;
      if (this.isPatch) {
        // this.taskDataList.forEach((item) => {
        this.multipleSelection.forEach((item) => {
          // if (item.checked) {
            let obj = {
              tenantGuid: item.tenantGuid,
              taskDetailGuid: item.taskDetailGuid,
              taskContentType: item.taskContentType,
              bizGuid: item.bizGuid,
              staffGuid: item.staffGuid,
              staffName: item.staffName,
              accountMonth: item.accountMonth,
              bizData: item.bizData,
              attach: this.extractAttachUrls(item.bizData),
            };
            this.bizItems.push(obj);
          // }
        });
      }
      let query = {
        reApprove: this.reApprove, // 征得企业同意
        revokeCause: this.revokeCause, // 撤回原因
        serviceTenantGuid: localStorage.guid,
        bizItems: this.bizItems,
        approvalState: this.approvalState,
        checkedIssues: this.approvalState == 'R' ? [] : this.checkedIssues,
        issuesDesc: this.issuesDesc, // !运营人员原因说明
        attach:this.attach.length?this.attach:null,//整改参考照片
      };

      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/task-audit/v2/task/revoke-audit`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.fullscreenLoading = false;
            this.$message.success('撤回重审成功');
            this.dialogVisible = false;
            this.checkedIssues = [];
            if (this.taskDataList.length == this.bizItems.length && this.page.pageIndex > 1) {
              this.page.pageIndex = this.page.pageIndex - 1;
            }
            // this.page.pageIndex = 1;
            this.$refs.multipleTable?.clearSelection();
            this.getData(3);
          } else {
            this.$message.error('撤回重审失败');
            this.fullscreenLoading = false;
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    //获取审核选项-单个
    getAuditData(item) {
      let self = this;
      let query = {
        serviceTenantGuid: localStorage.guid,
        taskDetailGuid: item.taskDetailGuid,
        taskContentType: item.taskContentType,
        bizGuid: item.bizGuid,
        isPass: this.approvalState,
        tenantGuid: item.tenantGuid,
        organisationGuid: item.organisationGuid,
      };
      this.getRulesParam = JSON.parse(JSON.stringify(query)) // !记录参数
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-audit/task/get-rules`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data) {
            // self.reasonList = res.data.data;
            self.reasonList = this.getList(res.data.data);
          } else {
            self.reasonList = [];
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取审核选项-批量
    getAuditDataPatch() {
      let self = this;
      // let flag = this.taskDataList.findIndex((i) => i.checked);
      let bizItems = [];
      // if (flag < 0) {
      //   this.$message.error('请勾选数据');
      //   return;
      // }
      if(this.multipleSelection.length<1){
        this.$message.error('请勾选数据');
        return;
      }
      // this.taskDataList.forEach((item) => {
      this.multipleSelection.forEach((item) => {
        // if (item.checked) {
          let obj = {
            tenantGuid: item.tenantGuid,
            organisationGuid: item.organisationGuid,
          };
          bizItems.push(obj);
        // }
      });
      let query = {
        serviceTenantGuid: localStorage.guid,
        tenantGuid: this.page.tenantGuid,
        organisationGuids: this.page.organisationGuid,
        bizItems,
        isPass: this.approvalState,
      };
      this.getRulesParam = JSON.parse(JSON.stringify(query)) // !记录参数
      return new Promise((resolve, reject) => {
        self.api
          .postJson(`/${serverConfig.msSalesPerformService}/task-audit/task/get-all-rules-with-org`, query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              if (res.data.data) {
                self.reasonList = this.getList(res.data.data);
              } else {
                self.reasonList = [];
              }
              resolve();
            } else {
              self.$message.error(res.data.msg);
            }
          });
      });
    },
    // 搜索审原因
    searchReason() {
      this.issuesDesc = ''
      let url = this.getRulesParam.bizGuid ? `/${serverConfig.msSalesPerformService}/task-audit/task/get-rules` : `/${serverConfig.msSalesPerformService}/task-audit/task/get-all-rules-with-org`
      let param = {
        ...this.getRulesParam,
        evaluationRuleDesc:this.evaluationRuleDesc
      }
      return new Promise((resolve, reject) => {
        this.api
          .postJson(url, param)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              if (res.data.data) {
                this.reasonList = this.getList(res.data.data);
              } else {
                this.reasonList = [];
              }
              resolve();
            } else {
              this.$message.error(res.data.msg);
            }
          });
      });
    },
    //提交审核
    toAuditSubmit() {
      if (this.reApprove) {

        if (!this.revokeCause) {
          this.$message.error('请填写撤回原因');
          return;
        }
      }
      if (this.approvalState == 'N' && !this.checkedIssues.length) {
        this.$message.error('请选择不合格原因');
        return;
      }
      if (this.approvalState == 'P' && !this.checkedIssues.length) {
        this.$message.error('请选择部分合格原因');
        return;
      }
      if (
        (this.approvalState == 'P' ||
          this.approvalState == 'N' ||
          (this.approvalState == 'Y' && this.checkedIssues.length)) &&
        !this.issuesDesc
      ) {
        this.$message.error('请填写原因说明');
        return;
      }
      if (this.currentTask.revoke ) {//|| this.batchRevoke
        this.toRevokeAudit();
      } else {
        this.toAuditRequire();
      }
    },
    // 批量审核 tpye 1 批量评审 2批量撤回重审
    pitchAudit(type) {
      if (!this.taskDataList.length) {
        this.$message.error('暂无数据');
        return;
      }
      if(this.multipleSelection.length<1){
        this.$message.error('请勾选数据');
        return;
      }
      this.isPatchDownload = false;
      this.batchRevoke = type === '2';
      this.isPatch = !this.isPatch;
    },
    //全选
    // handleCheckAllChange() {
    //   console.log('1');
    //   if (this.isPatch) {
    //     console.log('3');

    //     if (this.checkAll) {
    //       this.taskDataList.forEach((i) => {
    //         if (i.settleState !== 'Y' && i.tenantAgreeFlag !== 'A') i.checked = true;
    //       });

    //     } else {
    //       this.taskDataList.forEach((i) => {
    //         // if (i.settleState !== 'Y' && i.tenantAgreeFlag !== 'A')
    //          i.checked = false;
    //       });
    //     }
    //     this.taskDataList.forEach((i) => {
    //         this.$nextTick(() => {
    //           this.$refs.multipleTable.toggleRowSelection(i, i.checked);
    //           // this.$refs.dataTable.clearSelection()
    //         });
    //       });
    //     console.log('..',this.taskDataList,this.checkList);

    //   } else if (this.isPatchDownload) {
    //     if (this.checkAll) {
    //       this.taskDataList.forEach((i) => {
    //         i.checked = true;
    //       });
    //     } else {
    //       this.taskDataList.forEach((i) => {
    //         i.checked = false;
    //       });
    //     }
    //   }
    // },
    //todo tab切换钩子
    changeTab(index, item) {
      // this.queryBoxFn(item); // // 企业满意度相关筛选条件展示逻辑
      this.isPatch = false;
      // this.batchRevoke = null; // 重置批量撤回重审开关
      delete this.page.tenantApproveState; // 删除企业评价入参
      this.page.approvalState = item.value;
      this.activeTab = index;
      this.activeTabItem = item;
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData(2);
    },
    //todo tab切换钩子
    changeTab2(index, item) {
      this.isPatch = false;
      // this.batchRevoke = null; // 重置批量撤回重审开关
      this.queryBoxFn2(item);
      this.page.approvalState = 'Y';
      this.activeTab2 = index;
      this.activeTabItem2 = item;
      this.getData(2);
    },
    queryBoxFn(item) {
      // 企业满意度相关筛选条件展示逻辑
      if (item) {
        if (item.name === '全部') {
          this.page.settleState = null;
          this.page.isImprove = null;
        }
        if (item.name === '待审批') {
          this.page.settleState = 'N';
        }
        if (item.name === '合格' || item.name === '部分合格') {
          // # 企业一件反馈显示逻辑
          this.showFeedbackStatus = true;
        } else {
          this.showFeedbackStatus = false;
        }
        if (item.name === '部分合格' || item.name === '不合格') {
          // # 是否整改显示逻辑
          this.showRectification = true;
        } else {
          this.showRectification = false;
          this.page.isImprove = null;
        }
        if (item.name === '全部' || item.name === '合格' || item.name === '不合格' || item.name === '部分合格') {
          // # 是否结算显示逻辑
          this.showSettleAccounts = true;
          this.page.settleState = null;
        } else {
          this.showSettleAccounts = false;
        }
      }
    },
    queryBoxFn2(item) {
      // 企业tab切换
      if (item) {
        if (item.name === '待评价') {
          this.page.tenantApproveState = 'U';
        }
        if (item.name === '满意') {
          this.page.tenantApproveState = 'Y';
        }
        if (item.name === '不满意') {
          this.page.tenantApproveState = 'N';
        }
      }
    },
    comfirmSearch() {},
    handleSizeChangeDetail(val) {
      let self = this;
      self.pageDetail.pageSize = val;
    },
    handleCurrentChangeDetail(val) {
      let self = this;
      self.pageDetail.pageIndex = val;
    },
    searchButton() {
      this.getData(2);
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData(3);
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      // this.checkAll = false;
      this.getData(3);
    },
    // 拍照要求勾选事件
    checkedIssuesChange(newVal, oldVal) {
      if (newVal.length && newVal.length > oldVal.length) {
        let arr = [];
        if (newVal && Array.isArray(newVal)) {
          let len = newVal.length;
          let item = newVal[len - 1];
          arr.push(`${len}、${item.evaluationRuleDesc}`);
        }
        this.issuesDesc = this.issuesDesc + arr.join('\n') + '\n';
      }
    },
    // 原因说明输入事件
    checkedIssuesTextEvent(val) {
      // if (!/^[a-zA-Z0-9 _-、%()（），.。,\-\u4e00-\u9fa5\n]+$/.test(val) && val) {
      //   // this.disabledInput = true;
      //   this.openMessageBox();
      // } else {
      //   // this.disabledInput = false;
      // }
    },
    openMessageBox() {
      this.$NewMessage.warning({
        message: '仅可输入汉字、英文、数字、下划线【_】、减号【-】',
      });
    },
    // 获取企业的意见
    getCorporateOpinion(text) {
      return `\n ${text}`;
    },
    // 获取运营评审内容
    getCheckedIssues(checkedIssues) {
      let str = '';
      checkedIssues.forEach((item, i) => {
        str += `${i + 1}.${item.evaluationRuleDesc}\n`;
      });
      return str;
    },
    // todo根据企业\部门\核算月获取任务包列表 tenantGuid organisationGuid accountMonth
    getTaskPackageList() {
      let { page } = this;
      let param = JSON.parse(JSON.stringify(page));
      let query = {
        pageSize: -1,
        pageIndex: 1,
        tenantGuid: page.tenantGuid,
        state: ["已派发", "部分结算", "已结算", "已完结"],
        // accountMonth: param.accountMonth ? param.accountMonth.replace('-', '') : '',
        taskContentType:["WJDC"],
        isExcludeDataPermission:true,
        curTenantGuid: localStorage.guid,
        orderColumn: "send_time",
      };
      if(this.monthType=='考核月'){
        query.accountMonth = param.accountMonth ? param.accountMonth.replace('-', '') : '';
      }else{
        query.belongAccountMonth = param.accountMonth ? param.accountMonth.replace('-', '') : '';
      }
      return this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list-todo`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data && res.data.data.records) {
            this.taskPackageList = res.data.data.records||[];
            // this.page.taskMainGuid = this.taskPackageList.length?this.taskPackageList[0].guid:'';

            // this.getSurveyList()
          } else {
            this.taskPackageList = [];
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // ! 数组分类
    getList(arr) {
      if (!arr.length) return [];
      let map = {};
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        let ai = arr[i];
        if (!map[ai.evaluationContent]) {
          map[ai.evaluationContent] = [ai];
        } else {
          map[ai.evaluationContent].push(ai);
        }
      }
      Object.keys(map).forEach((key) => {
        res.push({
          evaluationContent: key,
          list: getSortList(map[key],'childOrderNum','升序'),
        });
      });

      return res;
    },
    handleClick(tab, event) {
      this.isPatch = false;
      this.$forceUpdate()
      if (this.activeTabItem || this.activeTabItem2) {

        if (this.activeName === 'first' && this.activeTabItem) {
          this.changeTab(this.activeTab, this.activeTabItem);
        } else if (this.activeName === 'second' && this.activeTabItem2) {
          this.changeTab2(this.activeTab2, this.activeTabItem2);
        }
      } else {
        if (this.activeName === 'first') {
          this.getData(1);
        } else if (this.activeName === 'second') {
          this.getData(1);
        }
      }
    },
    // 查看评审记录
    async viewReviewRecords(item, type) {
      this.fullscreenLoading = true;
      let res = [];
      if (type === 'tenant') {
        res = await this.approveTenantHistory(item);
      } else if (type === 'service') {
        res = await this.approveServiceHistory(item);
      }

      console.log('p',res);

      if (res && res.length) {
        this.$root.$emit('viewReviewRecords', {
          openReviewRecords: true,
          title: type === 'service' ? '运营历史审批原因' : '企业历史评价',
          type,
          reviewList: res,
          currentTab: this.activeTabItem,
        });
      }
      this.fullscreenLoading = false;
    },
    // type 对应的按钮 Y合格P部分合格N不合格
    addClassName(item, type) {
      // return
      let className = '';
      let lookUp = {
        Y: 'is-selected-y',
        P: 'is-selected-p',
        N: 'is-selected-n',
      };
      if (item.revoke && item.approveState) {
        // 撤回重审,取消按钮勾选标识
        className = '';
      } else {
        // !撤回重审待确认时状态勾选逻辑
        if (item.checkState === type && item.tenantAgreeFlag === 'A') {
          className = lookUp[item.checkState];
        } else {
          className = 'is-disabled-btn';
        }
        // !正常评审状态勾选逻辑
        if (item.tenantAgreeFlag !== 'A') {
          // 非待确认状态
          if (item.approveState === type) {
            className = lookUp[type];
          } else if (item.approveState === null) {
            className = '';
          } else {
            className = 'is-disabled-btn';
          }
        }
      }
      return className;
    },
    approveServiceHistory(item) {
      let self = this;
      if(item.isImprove!=='Y'&&!item.approveState){
        self.$message.error('无历史审核记录');
        return
      }
      return new Promise((resolve, reject) => {
        self.api
          .get(
            `/${serverConfig.msSalesPerformService}/task-audit/v2/task/approve-service-history?tenantGuid=${item.tenantGuid}&bizGuid=${item.bizGuid}`,
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {

              if(!res.data.data){
                this.$message.error('无历史审核记录');
                this.fullscreenLoading = false;
                return
              }else{
                resolve(res.data.data);
              }

            } else {
              self.$message.error(res.data.msg);
            }
          });
      });
    },
    approveTenantHistory(item) {
      let self = this;
      return new Promise((resolve, reject) => {
        self.api
          .get(
            `/${serverConfig.msSalesPerformService}/task-audit/v2/task/approve-tenant-history?tenantGuid=${item.tenantGuid}&bizGuid=${item.bizGuid}`,
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              resolve(res.data.data);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      });
    },
    clearTenantAgreeFlag(val) {
      if (!val) {
        this.page.tenantAgreeFlag = null;
      }
    },
    showbatchDownload() {
      if (!this.taskDataList.length) {
        this.$message.error('暂无数据');
        return;
      }
      this.isPatch = false;
      this.isPatchDownload = !this.isPatchDownload;
    },
    // todo 批量下载
    async batchDownload() {
      try {
        this.fullscreenLoading = true
        let resTask = await this.getAttachment(); // !拿到下载的附件信息
        if (resTask.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let checkFile = await this.checkFile(resTask.data.data); // !判断附件大小
          if (checkFile.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (checkFile.data.data) {
              let resFile = await this.downloadTempFile(resTask.data.data); // !打包下载
              this.fullscreenLoading = false
              if (resFile.data.code) {
                this.$message.error(resFile.data.msg);
              } else {
                let blob = new Blob([resFile.data], { type: 'application/zip' });
                let fileName = resTask.data.data.packageName || `附件-${this.$moment(new Date()).format('YYYYMMDD')};`;
                let objectUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.download = fileName;
                link.href = objectUrl;
                link.click();
              }
            }
          } else {
            this.$message.error(res.data.msg);
          }
        } else {
          this.$message.error(resTask.data.msg);
        }
      } catch (error) {
        this.$message.error('下载失败, 请重试');
      }
    },
    // 获取附件内容
    getAttachment() {
      // let flag = this.taskDataList.findIndex((i) => i.checked);
      // if (flag < 0) {
      //   this.$message.error('请勾选数据');
      //   return;
      // }
      if(this.multipleSelection.length<1){
        this.$message.error('请勾选数据');
        return;
      }
      let param = [];
      if (this.isPatchDownload) {
        // this.taskDataList.forEach((item) => {
        this.multipleSelection.forEach((item) => {
          // if (item.checked) {
            let obj = {
              tenantGuid: item.tenantGuid,
              createTime: item.createTime,
              accountMonth: item.accountMonth,
              tenantName: item.tenantName,
              taskMainGuid: item.taskMainGuid,
              taskContentType: item.taskContentType,
              taskContentName: item.taskContentName,
              staffGuid: item.staffGuid,
              staffName: item.staffName,
              mobileNo: item.mobileNo,
              bizData: item.bizData,
            };
            param.push(obj);
          // }
        });
      }
      return this.api.postJson(`/${serverConfig.msSalesPerformService}/task-audit/data/download-attachment`, param);
    },
    // 判断文件大小
    checkFile(param) {
      return this.api.postJson(`/${serverConfig.msCommonAdminCloudService}/zip/download-check`, param);
    },
    // 批量下载
    downloadTempFile(param) {
      return this.api.postJsonD(`/${serverConfig.msCommonAdminCloudService}/zip/download-temp-file`, param);
    },
    prevFile(path) {
      let src = 'https://view.officeapps.live.com/op/view.aspx?src=' + path;
      window.open(src, '_blank');
    },
    prevVideo(path){
      this.dialogVisibleVodeo = true;
      this.videoPath = path;
     // window.open(path, '_blank');
    },
    formatSeconds(value) {
      let theTime = parseInt(value); // 秒
      let theTime1 = 0; // 分
      let theTime2 = 0; // 小时

      if (theTime > 60) {
        theTime1 = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);

        if (theTime1 > 60) {
          theTime2 = parseInt(theTime1 / 60);
          theTime1 = parseInt(theTime1 % 60);
        }
      }
      let result = '' + parseInt(theTime) + '秒';
      if (theTime1 > 0) {
        result = '' + parseInt(theTime1) + '分' + result;
      }
      if (theTime2 > 0) {
        result = '' + parseInt(theTime2) + '时' + result;
      }
      return result;
    },
    // todo 获取XSBF产品信息
    getGoodsFile(item) {
      let goodsFileGuid = '';
      let { bizData, fieldConfig } = item;
      if (bizData['goodsFileGuid']) {
        goodsFileGuid = bizData['goodsFileGuid'];
      } else {
        this.$message.error('暂无产品图片');
        return;
      }
      this.api.get(`/${serverConfig.msSalesPerformService}/contentManage/detail/${goodsFileGuid}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let { pictureFile, title } = res.data.data;
          this.$root.$emit('viewGoodsFile', {
            openReviewRecords: true,
            title: title,
            type: 'goodsFile',
            reviewList: pictureFile,
          });
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //点击行选中
    handleClickTableRow(row, event, column) {
      // this.$refs.multipleTable.toggleRowSelection(row);
    },
    selectEnable(row) {
      // scope.row.tenantAgreeFlag !== 'A'
      if (row.settleState === 'Y'||row.tenantAgreeFlag === 'A') {
        return false;
      } else{
        return true
      }
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      if (val && val.length > 0) {
        val.forEach(function (item) {
          self.multipleSelection.push(item);
        });

      }
      if(self.multipleSelection.length==self.taskDataList.length){
          // this.checkAll=true
          this.$forceUpdate()
        }else{
          // this.checkAll=false
          this.$forceUpdate()
        }

    },
    handleSelectionAll(val){
      console.log('65',val);
      if(val&&val.length==this.taskDataList.length){
          // this.checkAll=true
          this.$forceUpdate()
        }else{
          // this.checkAll=false
          this.$forceUpdate()
        }
    },
    toExportInHandle () {
      let query = {
        tenantGuid: this.page.tenantGuid, 
        accountMonth: this.page.accountMonth, 
        from: 'questionnaireAudit',
        serviceProviderType: this.serviceProviderType,
      }
      if (this.page.taskMainGuidList.length) {
        query.taskMainGuidList = JSON.stringify(this.page.taskMainGuidList)
      }
      if (this.page.surveyTenantGuid) {
        query.surveyTenantGuid = this.page.surveyTenantGuid
      }
      this.$router.push({
        name: 'importTaskList',
        query
      })
    }
  },
};
</script>
<style lang="less" scoped>
.taskAudit {
  position: relative;
  overflow: hidden;
}
.search-area {
  border-radius: 0;
}
.tooltip-hidden .item {
  text-overflow:ellipsis!important;
}
// .tooltip-item .el-tooltip__popper.is-light {
//   width: 420px!important;
//   // margin-left: 10px; // 设置外边距为10px
// }
// .tooltip-item .popper__arrow {
//     margin-right: 10px; // 调整箭头与元素顶部的距离
//   }
.singe-line {
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
}
/deep/ .el-table-column--selection .cell {
  padding-right: 10px;
}
/deep/ .el-table th.el-table__cell>.cell .el-tooltip {
  white-space:nowrap !important;
  text-overflow:ellipsis!important;
  word-break:break-all;
  // text-wrap:nowrap !important;
}
/deep/ .el-table{

table-layout:fixed;

  th{
    .cell{
      white-space:nowrap !important;
      text-overflow:ellipsis;
      word-break:break-all;
      overflow: hidden;
      // text-wrap:nowrap !important
    }
    .cell :hover
    {
    text-overflow:inherit;
    overflow:visible;
    }
  }

}

.searchHead-top {
  height: 40px;
  color: #9d9d9d;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 6px;
  background: #fff;

  /deep/ .el-tabs__header {
    margin: 0;
  }
  /deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-top: 2px solid #4fa1a4;
    border-bottom: 0px;
  }
  /deep/ .el-tabs__item.is-active {
    color: #4fa1a4;
  }
  // /deep/ .el-tabs--card>.el-tabs__header {
  //   border-bottom:0px;
  // }
}
.searchHead {
  height: 40px;
  color: #9d9d9d;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 6px;
  margin-bottom: 8px;
  background: #fff;
}
.flex {
  display: flex;
}
.flex-column {
  flex-direction: column
}
.items-center {
  align-items: center
}
.grid {
  display: grid;
}

.grid-columns-2 {
  grid-template-columns: repeat(2, 1fr);
}
.img-text {
  align-items: center;
  justify-content: center; 
  white-space: normal; 
  overflow-wrap: break-word;
  padding: 4px 6px;
  .text-bage {
    border-radius: 50%;
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
  }
  .border-b-1 {
    border-bottom: 1px solid #000;
  }
  .btn {
    color: #212121;
    border-bottom: 1px solid #333;
  }

}

.btn-move {
  width: 23px;
  margin-right: 8px
}
.btn-left {
  width: 23px;
  height: 40px;
  opacity: 0.25;
  background: #000000;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-left:hover {
  opacity: 0.45;
}

.w74 {
  width: 74px;
}
.searchHead-left {
  display: flex;
}
.searchHead .tab {
  margin: 0 13px;
  cursor: pointer;
  position: relative;
}
.searchHead .active {
  color: #232323;
}
.searchHead .active .line {
  width: 80%;
  height: 3px;
  background: #4fa1a4;
  margin-top: 4px;
  position: absolute;
  left: 10%;
}
.searchHead .active1 .line1 {
  width: 100%;
  height: 3px;
  background: #4fa1a4;
  margin-top: 4px;
  position: absolute;
  left: 0;
  top: 0;
}
.contentBox {
  position: relative;
}
.sumLine {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* padding: 10px; */
  font-size: 16px;
  background: #fff;
  /* border-bottom: 1px solid #e9eef3; */
}
.headBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  margin: 8px 0 2px 0;
  box-shadow: 2px 2px 10px 4px rgba(0, 0, 0, 0.2);
}

.sumLine span {
  color: #4fa1a4;
}
.sumLine .pitch {
  padding: 6px 8px;
  border: 1px solid #c1c1c1;
  font-size: 14px;
  cursor: pointer;
}
.sumLine .pitch.active {
  color: #4fa1a4;
  border: 1px solid #4fa1a4;
}

.sumLine .pitch {
  padding: 6px 8px;
  border: 1px solid #c1c1c1;
  font-size: 14px;
  cursor: pointer;
  margin-left: 16px;
}
.box {
  background: #fff;
  padding: 0 0px 0 16px;
  display: flex;
  margin-bottom: 8px;
  /* width: 100%; */
  box-sizing: border-box;
  position: relative;
}
.box .left {
  flex: 1;
  border-right: 1px solid #e9eef3;
  overflow: hidden;
  position: relative;
}
.box .left .top {
  display: flex;
  /* align-items: center; */
  /* border-bottom: 1px solid #e9eef3; */
  padding: 14px 0;
  position: relative;
}
.box .left .top .tag {
  flex-shrink: 0;
  width: 130px;
  /* height: 45px; */
  line-height: 20px;
  padding: 12px 5px;
  display: inline-block;
  color: #fff;
  background: #4fa1a4;
  box-sizing: border-box;
  /* text-overflow: ellipsis;
  overflow: hidden; */
  white-space: normal;
  border-radius: 0;
}
.box .left .top .el-row {
  width: calc(100% - 130px);
  flex: 1;
  padding: 0 24px;
  text-align: left;
  box-sizing: border-box;
}
.box .left .top .el-col-8 {
  display: flex;
  line-height: 26px;
}
.box .left .top .label {
  display: inline-block;
  flex-shrink: 0;
  /* width: 70px; */
  padding-right: 10px;
  text-align: left;
  color: #9d9d9d;
}
.top .task-title-sort {
  width: 130px;
  padding-top: 10px;
}
.box .item-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.imgList {
  padding: 14px 14px 14px 0;
  overflow-x: auto;
  white-space: nowrap;
  text-align: left;
  margin-left: 155px;
  border-top: 1px solid #e9eef3;
}
.border-top-none {
  border-top: none;
}
.imgList > img {
  width: 120px;
  height: 120px;
  margin-right: 8px;
}
.showMore {
  position: absolute;
  right: 0;
  bottom: 61px;
  width: 24px;
  height: 96px;
  line-height: 96px;
  background: rgba(0, 0, 0, 0.39);
  color: #fff;
  font-size: 20px;
  border-radius: 4px 0 0 4px;
  cursor: pointer;
}
.listBox {
  overflow-y: auto;
}

.box .right {
  width: 185px;
  // min-height: 260px;
  // max-height: 320px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  // padding: 10px 0;
  position: relative;
}

.box .right .butt-reset,
.pitchBtn div {
  height: 32px;
  line-height: 32px;
  width: 110px;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  z-index: 100;
}

.box .right .butt1,
.pitchBtn .butt1 {
  background: #ebf6f7;
  border: 1px solid #4fa1a4;
  color: #4fa1a4;
}

.box .right .butt2,
.pitchBtn .butt2 {
  background: #fff2f4;
  border: 1px solid #fc808b;
  color: #fb2323;
  // margin-top: 12px;
}

.box .right .butt4,
.pitchBtn .butt4 {
  cursor: pointer;
  height: 32px;
  line-height: 32px;
  width: 110px;
  display: inline-block;
  // margin-top: 12px;
  background: #fffbf2;
  border: 1px solid #ffcb78;
  color: #ff991c;
}
.box .right .status-remark {
  width: 48px;
  height: 48px;
  /* background-color: #fff; */
  position: absolute;
  right: 0;
  top: 0;
}
.box .status-remark {
  width: 48px;
  height: 48px;
  /* background-color: #fff; */
  position: absolute;
  right: 0;
  top: 0;
}
/* 右上小 */
.status-remark .ico-angle1 {
  display: inline-block;
  width: 0;
  height: 0;
  overflow: hidden;
  font-size: 0;
  /* border-right: 24px solid #fff; */
  border-bottom: 24px dashed transparent;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 20;
}
/* 右上大 */
.status-remark .ico-angle2-Y {
  display: inline-block;
  width: 0;
  height: 0;
  /* overflow: hidden; */
  font-size: 0;
  border-right: 48px solid #51a0a3;
  border-bottom: 48px dashed transparent;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
}
.status-remark .ico-angle2-N {
  display: inline-block;
  width: 0;
  height: 0;
  /* overflow: hidden; */
  font-size: 0;
  border-right: 48px solid #fe9b2d;
  border-bottom: 48px dashed transparent;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
}
/* 左下大 */
.status-remark .ico-angle3 {
  display: inline-block;
  width: 0;
  height: 0;
  overflow: hidden;
  font-size: 0;
  /* border-left: 48px solid #fff; */
  border-top: 48px dashed transparent;
  position: absolute;
  left: 0;
  bottom: 0;
}
.status-remark .remark-text {
  padding-top: 5px;
  width: 42px;
  height: 48px;
  transform: rotate(45deg);
  font-size: 12px;
  color: #fff;
}

// 右上角标签
.status-remark {
  width: 48px;
  height: 48px;
  /* background-color: #fff; */
  position: absolute;
  right: 0;
  top: 0;
  .ico-angle1 {
    display: inline-block;
    width: 0;
    height: 0;
    overflow: hidden;
    font-size: 0;
    /* border-right: 24px solid #fff; */
    border-bottom: 24px dashed transparent;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 20;
  }
  .ico-angle2-Y {
    display: inline-block;
    width: 0;
    height: 0;
    /* overflow: hidden; */
    font-size: 0;
    border-right: 48px solid #51a0a3;
    border-bottom: 48px dashed transparent;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
  }
  .ico-angle2-N {
    display: inline-block;
    width: 0;
    height: 0;
    /* overflow: hidden; */
    font-size: 0;
    border-right: 48px solid #fe9b2d;
    border-bottom: 48px dashed transparent;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
  }
  .ico-angle2-A {
    display: inline-block;
    width: 0;
    height: 0;
    /* overflow: hidden; */
    font-size: 0;
    border-right: 48px solid #b2b2b2;
    border-bottom: 48px dashed transparent;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
  }
  .ico-angle3 {
    display: inline-block;
    width: 0;
    height: 0;
    overflow: hidden;
    font-size: 0;
    /* border-left: 48px solid #fff; */
    border-top: 48px dashed transparent;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .remark-text {
    padding-top: 5px;
    width: 42px;
    height: 48px;
    transform: rotate(45deg);
    font-size: 12px;
    color: #fff;
  }
}

.butt-info {
  height: 32px;
  line-height: 32px;
  background: #fff;
  color: #232323;
}
.butt3 {
  cursor: pointer;
  height: 32px;
  line-height: 32px;
  background: #fff;
  color: #232323;
}
.cancel {
  cursor: pointer;
  height: 32px;
  line-height: 32px;
  background: #fff;
  border: 1px solid #c1c1c1;
  color: #232323;
}
.cancel-butt {
  cursor: pointer;
  height: 32px;
  line-height: 32px;
  background: #fff;
  border: 1px solid #c1c1c1;
  color: #232323;
}
.butt5 {
  background: #fff;
  border: 1px solid #d9d9d9;
  color: #4fa1a4;
  height: 32px;
  line-height: 32px;
  width: 100%;
  text-align: center;
  display: inline-block;
  position: absolute;
  bottom: 0;
}
.butt6 {
  display: flex;
  flex-flow: column;
  justify-content: center;
  background: #fff;
  border: 1px solid #d9d9d9;
  min-height: 32px;
  width: 100%;
  text-align: center;
}
.butt7 {
  background: #ebf6f7;
  color: #4fa1a4;
  height: 32px;
  line-height: 32px;
  width: 100%;
  text-align: center;
  display: inline-block;
  // position: absolute;
  // top: 0;
}
.pitchAll {
  display: flex;
  align-items: center;
  width: calc(100% - 283px);
  background: #fff;
  height: 60px;
  padding: 0 20px;
  position: fixed;
  bottom: 0;
  box-shadow: 2px 2px 10px 4px rgba(0, 0, 0, 0.2);
  z-index: 999;
}
.pitchBtn {
  flex: 1;
  text-align: center;
}
.taskAudit /deep/ .el-dialog__body {
  padding: 0;
}
.dialogCon {
  border-top: 1px solid #dcdee0;
  text-align: left;
  padding: 10px 20px;
}
.dialogCon /deep/ .el-checkbox {
  padding: 0 14px;
  width: 40%;
  // height: 40px;
  // line-height: 40px;
  .el-checkbox__label {
    color: #212121;
  }
}
.dialogCon .dialogCon-checkbox /deep/ .el-checkbox-group {
  display: block;
}
.dialogCon .dialogCon-checkbox {
  max-height: 400px;
  overflow-y: auto;
  /deep/.el-form-item__content {
    line-height: 25px;
  }
  /deep/.el-form-item {
    margin-bottom: 0px;
  }
}
.dialogCon-checkbox-type {
  width: 100%;
}
.type-check-list {
  margin-top: 4px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.type-check-item {
  width: 50%;
}

.butt-text-Y {
  color: #4fa1a4;
  cursor: default !important;
}
.butt-text-N {
  color: red;
  cursor: default !important;
}
.butt-text-S {
  color: #ff741e;
  cursor: default !important;
}
.butt-tip {
  line-height: 20px !important;
  margin-top: 10px;
  padding: 0 16px;
  text-align: left;
}
.task-table-block {
  /* padding-left: 155px; */
  padding-right: 10px;
  margin: 10px 0;
}
.table-img-box {
  padding: 20px;
}
.checkbox-hover {
  display: flex;
  white-space: normal;
  padding: 12px 0;
}
.checkbox-hover:hover {
  background: rgba(248, 248, 248, 0.39);
}
.dialogCon .el-checkbox-group {
  width: 100%;
  display: flex;
  flex-flow: wrap;
}
.search-area .el-col-8 {
  display: flex;
  justify-content: space-between;
}
.search-area .ipt-sty {
  flex: 1;
}
.no-data {
  padding: 30px;
  background: #fff;
}
.taskAudit .el-table__expand-icon {
  display: none;
}
.search-area-div {
  width: 100px;
  text-align: right;
  /* flex-shrink: 0; */
}
.ipt-sty {
  flex: 1;
}
.el-col-6 {
  margin-bottom: 8px;
  display: flex;
}
.el-col-8 {
  display: flex;
  /* margin-bottom: 15px; */
}
.listBox .el-col-24 {
  display: flex;
  // margin-bottom: 15px;
}
.popover-txt {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.focusing {
  border: none;
}
.el-popover--plain {
  padding: 8px 12px !important;
}
// .have-margin-bottom10 {
//   margin-bottom: 10px;
// }
// .have-margin-bottom20 {
//   margin-bottom: 20px;
// }
// .have-margin-bottom30 {
//   margin-bottom: 30px;
// }
// .have-margin-bottom40 {
//   margin-bottom: 40px;
// }
// .have-isImprove {
//   margin-top: 40px;
// }
.have-margin-top12 {
  margin-top: 12px;
}
// .have-margin-top40 {
//   margin-top: 40px;
// }
.z-index100 {
  z-index: 100;
}
/deep/.el-dialog__footer {
  border-top: 1px solid #d9d9d9;
}
.dialog-title {
  text-align: left;
  width: 240px;
  height: 27px;
  font-family: PingFang SC;
  font-size: 18px;
  color: #212121;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 400;
}
.cols {
  background: #fff;
  display: flex;
  padding: 8px 0px;
  .col-itms {
    display: flex;
    align-items: center;
    .title {
      width: 70px;
      text-align: left;
      margin-right: 16px;
      margin-bottom: 0;
      padding-left: 0;
      font-weight: normal;
      font-size: 14px;
      word-break: keep-all;
    }
  }
}
.reason-review {
  border-bottom: 1px solid;
  cursor: pointer;
  font-size: 12px;
}
.text-red {
  font-size: 12px;
  cursor: pointer;
  color: #fb2323;
  border-bottom: 1px solid #fb2323;
}
.text-green {
  font-size: 12px;
  cursor: pointer;
  color: #4fa1a4;
  border-bottom: 1px solid #4fa1a4;
}
.is-csbr-task {
  position: absolute;
  left: 5px;
  background: #4fa1a4 url('../../assets/icon/taskIcon.png') no-repeat left center !important;
  background-size: 20px 20px !important;
  width: 20px;
  height: 20px;
}
.has-csbr-task {
  padding: 12px 5px 12px 21px !important;
}
.is-selected-y {
  // background: #f2f7f7 url('../../assets/approveState-y.png') no-repeat right bottom !important;
  // background-size: 18px 18px !important;
  // border: 1px solid #4fa1a4 !important;
}
.is-selected-p {
  // background: #fffbf2 url('../../assets/approveState-p.png') no-repeat right bottom !important;
  // background-size: 18px 18px !important;
  // border: 1px solid #fecc7d !important;
}
.is-selected-n {
  // background: #fff2f4 url('../../assets/approveState-n.png') no-repeat right bottom !important;
  // background-size: 18px 18px !important;
  // border: 1px solid #fb828c !important;
}
.is-disabled-btn {
  cursor: no-drop !important;
  color: #b2b2b2 !important;
//   background: #f5f5f5 !important;
//   border: 1px solid rgba(217, 217, 217, 1) !important;
}
.mouse-disabled {
  cursor: no-drop !important;
  color: #999999!important;
}
.goods-File-Name {
  border-bottom: 1px solid #212121;
  cursor: pointer;
}
.goods-File-Name:hover {
  color: #f55353;
  border-bottom-color: #f55353;
}
.butt-transparent {
  // flex: 1;
  opacity: 0;
}
/deep/ .el-dialog.is-fullscreen{
  overflow: hidden;
}
/deep/ .el-select__tags-text{
  max-width: 60px;
}
/deep/.el-input--prefix .el-input__inner{
  padding-right: 5px;
}
/deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
  float: none;
}
/deep/ .el-upload-list__item {
  width: 100px;
  height: 100px;
}
.w82{
  width: 82px;
}
</style>
<style lang="less">
  .el-image-viewer__actions{//图片预览的工具
  // 样式与#app同级，只能写在非scoped里了
    top:50%;
    left: 80%;
    transform: rotate(90deg);
    i{
      transform: rotate(-90deg);
    }
  }
  .el-tooltip__popper.is-light {
    /* border: none!important; */
    /* box-shadow: 1px 1px 3px #E5E5E5!important; */
    max-width: 420px!important;
    margin-left: 60px;
  }


</style>
    